class ActivitiApplyRequestDto {
  /** 提交人备注 */
  applyMemo = "";

  /** 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** 标记 */
  flag = undefined;

  /** 物流审核人 */
  logisticsOwnerCode = "";

  /** 工作流实例ID */
  processInstanceId = "";

  /** 采购审核人 */
  purchaseOwnerCode = "";

  /** 工作流TaskID */
  taskId = "";
}

class ApprovalBeforeRequestDto {
  /** 业务Key，例如盘点单号 */
  businessKey = "";

  /** 页大小 */
  pageNumber = undefined;

  /** 页号 */
  pageSize = undefined;

  /** 流程定义key,盘点：InventoryApproval */
  processKey = "";
}

class ApprovalRequestDto {
  /** 审批状态：待提交：-1，已驳回：0；已通过<流程结束传>：1；审批中<只要流程没结束都是传该状态>：2；已撤回：3 ；已挂起：4；已删除：5；流程终止：-2 */
  approvalStatus = undefined;

  /** 审批意见 */
  approvalSug = "";

  /** 审批流程号 */
  businessKey = "";

  /** 表单数据 */
  formData = undefined;

  /** 本次操作 */
  operateTaskDto = new CurrentTaskDto();

  /** 流程实例id */
  processInstanceId = "";

  /** 流程定义key */
  processKey = "";

  /** 是否需要开启审批流 */
  startApproval = false;

  /** 驳回目标节点 */
  taskDto = new TaskDto();
}

class ApproveBatchRequestDto {
  /** ids */
  ids = [];

  /** 是否同意 0 否 1是 */
  isAgree = undefined;

  /** 备注 */
  remark = "";
}

class AssigneeDto {
  /** 操作人内部编号 */
  userCode = "";

  /** 操作人名称 */
  userName = "";
}

class AssociatedFilesRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 文件类型 */
  fileCategory = "";

  /** 文件名称 */
  fileName = "";

  /** 文件地址 */
  fileUrl = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 来源标识 */
  sourceId = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class AssociatedFilesResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 文件类型 */
  fileCategory = "";

  /** 文件名称 */
  fileName = "";

  /** 文件地址 */
  fileUrl = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 来源标识 */
  sourceId = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class BatchImportSettlementRequestDto {
  /** 结算信息附件 */
  settlementFile = "";

  /** TMS单号 */
  tmsno = "";
}

class CabinAdvanceCreateRequestDto {
  /** 调拨单号 */
  aono = "";

  /** 箱数 */
  boxQty = undefined;

  /** centerId */
  centerId = "";

  /** SKU明细 */
  detailCreateRequestDtos = [];

  /** 渠道编号（平台） */
  platformKey = "";

  /** 渠道名字（平台） */
  platformName = "";

  /** 总数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** shipment */
  shipment = "";

  /** 运输方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车 */
  shippingType = undefined;

  /** 店铺信息 */
  shopMessage = "";

  /** 站点 */
  site = "";

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 调拨类型: 10 普通调拨,20 FBA调拨,30 三方调拨 */
  transferType = undefined;

  /** 体积 */
  volume = undefined;

  /** 重量 */
  weight = undefined;
}

class CabinAdvanceDetailCreateRequestDto {
  /** BU编码 */
  buCode = "";

  /** BU名称 */
  buName = "";

  /** SKU中文标题 */
  productSkuName = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 体积 */
  volume = undefined;

  /** 重量 */
  weight = undefined;
}

class CabinAdvanceDetailResponseDto {
  /** 调拨单号 */
  aono = "";

  /** BU编码 */
  buCode = "";

  /** BU名称 */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** SKU中文标题 */
  productSkuName = "";

  /** 数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** sku */
  sku = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 体积 */
  volume = undefined;

  /** 重量 */
  weight = undefined;
}

class CabinAdvanceMasterResponseDto {
  /** 调拨单号 */
  aono = "";

  /** 箱数 */
  boxQty = undefined;

  /** centerId */
  centerId = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 订舱计划号 */
  crno = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** SKU明细 */
  detailResponseDtos = [];

  /** 预订舱完成时间 */
  finishTime = "";

  /** id */
  id = undefined;

  /** 渠道编号 */
  platformKey = "";

  /** 渠道名字 */
  platformName = "";

  /** 采购负责人 */
  purchaseOwner = "";

  /** 采购负责人编号 */
  purchaseOwnerCode = "";

  /** 总数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** shipment */
  shipment = "";

  /** 运输方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车 */
  shippingType = undefined;

  /** 店铺信息 */
  shopMessage = "";

  /** 站点 */
  site = "";

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 状态：10 待预订，20 已预订，30 已取消 */
  status = undefined;

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 调拨类型: 10 普通调拨,20 调拨,30 三方调拨 */
  transferType = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 体积 */
  volume = undefined;

  /** 重量 */
  weight = undefined;
}

class CabinFactoryActualCabinetRequestDto {
  /** 工作流实例 */
  activitiApplyRequestDto = new ActivitiApplyRequestDto();

  /** 订舱计划号 */
  crno = "";

  /** PO明细 */
  poDetailRequestDtos = [];
}

class CabinFactoryCreateRequestDto {
  /** centerId */
  centerId = "";

  /** 订舱计划号 */
  crno = "";

  /** 直发类型: 10 自营调拨/第三方调拨 20 FBA调拨  */
  directType = undefined;

  /** 第三方附件名称 */
  fileName = "";

  /** 第三方附件url */
  fileUrl = "";

  /** 装柜类型: 10 散货,20 20GP,30 40HQ, 40 40GP */
  loadCabinType = undefined;

  /** 物流方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车 */
  logisticsType = undefined;

  /** 计划需求日期 */
  planNeedTime = "";

  /** 计划出货日期 */
  planShipmentTime = "";

  /** 产品标签附件名称 */
  productFileName = "";

  /** 产品标签附件url */
  productFileUrl = "";

  /** 备注 */
  remark = "";

  /** 站点 */
  site = "";

  /** SKU明细 */
  skuDetailRequestDtos = [];

  /** 状态：10 待提交，20 待采购审核 */
  status = undefined;

  /** 供应商 */
  supplier = "";

  /** 供应商Code */
  supplierCode = "";

  /** 调入交易主体编号 */
  targetTradeCompanyCode = "";

  /** 调入交易主体名称 */
  targetTradeCompanyName = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** VAT店铺信息 */
  vatShop = "";
}

class CabinFactoryDeliveryRequestDto {
  /** 工作流实例 */
  activitiApplyRequestDto = new ActivitiApplyRequestDto();

  /** 订舱计划号 */
  crno = "";

  /** 送仓凭证/装柜凭证 */
  deliveryFile = "";

  /** 发运时间 */
  deliveryTime = "";
}

class CabinFactoryInboundRequestDto {
  /** 工作流实例 */
  activitiApplyRequestDto = new ActivitiApplyRequestDto();

  /** 订舱计划号 */
  crno = "";

  /** PO明细 */
  poDetailRequestDtos = [];
}

class CabinFactoryLockWarehouseRequestDto {
  /** 工作流实例 */
  activitiApplyRequestDto = new ActivitiApplyRequestDto();

  /** centerId */
  centerId = "";

  /** 订舱计划号 */
  crno = "";

  /** SKU明细 */
  skuDetailRequestDtos = [];

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** VAT店铺信息 */
  vatShop = "";
}

class CabinFactoryOutboundRequestDto {
  /** 工作流实例 */
  activitiApplyRequestDto = new ActivitiApplyRequestDto();

  /** 订舱计划号 */
  crno = "";

  /** TO明细 */
  toDetailRequestDtos = [];
}

class CabinFactoryPickupCabinRequestDto {
  /** 工作流实例 */
  activitiApplyRequestDto = new ActivitiApplyRequestDto();

  /** 货柜号 */
  containerNo = "";

  /** 订舱计划号 */
  crno = "";

  /** 司机姓名 */
  driverName = "";

  /** 司机电话号码 */
  driverPhone = "";

  /** 车牌信息 */
  licensePlate = "";

  /** 提柜时间 */
  pickupCabinTime = "";

  /** 封条号 */
  sealno = "";

  /** 拖车代理 */
  trailerAgent = "";

  /** 拖车代理编码 */
  trailerAgentCode = "";

  /** 供应商内部代码 */
  vendorInternalCode = "";
}

class CabinFactoryPlanCabinetCabinRequestDto {
  /** 工作流实例 */
  activitiApplyRequestDto = new ActivitiApplyRequestDto();

  /** 订舱计划号 */
  crno = "";

  /** 最晚订船日期 */
  latestLoadBoatTime = "";
}

class CabinFactoryPurchaseExamineRequestDto {
  /** 工作流实例 */
  activitiApplyRequestDto = new ActivitiApplyRequestDto();

  /** 订舱计划号 */
  crno = "";

  /** 货好日期 */
  goodsFinishTime = "";

  /** SKU明细 */
  skuDetailRequestDtos = [];
}

class CabinFactoryReserveCabinRequestDto {
  /** 工作流实例 */
  activitiApplyRequestDto = new ActivitiApplyRequestDto();

  /** 订舱附件 */
  bookingCabinFile = "";

  /** 订舱完成时间 */
  bookingCabinTime = "";

  /** 是否校验CenterId：1是 0否 */
  checkCenterFlag = undefined;

  /** 订舱计划号 */
  crno = "";

  /** 截单日期 */
  endBillTime = "";

  /** ETA */
  etaTime = "";

  /** ETD */
  etdTime = "";

  /** 最晚送仓日期/装柜日期 */
  latestLoadCabinTime = "";

  /** 渠道服务编号 */
  logisticsChannelCode = "";

  /** 渠道服务名称 */
  logisticsChannelName = "";

  /** 渠道商编号 */
  logisticsProviderCode = "";

  /** 渠道商名称 */
  logisticsProviderName = "";

  /** 收货联系电话 */
  receivingContactNumber = "";

  /** 收货人 */
  receivingPersonnel = "";

  /** SO号 */
  soNo = "";

  /** 起运港地址 */
  startPortAddress = "";

  /** 起运港编号 */
  startPortCode = "";

  /** 起运港名称 */
  startPortName = "";

  /** 收货地址(到仓地址) */
  toWarehouseAddress = "";

  /** 供应商内部代码 */
  vendorInternalCode = "";

  /** 物流单号 */
  waybillNo = "";
}

class CabinFactoryToWarehouseRequestDto {
  /** 工作流实例 */
  activitiApplyRequestDto = new ActivitiApplyRequestDto();

  /** 订舱计划号 */
  crno = "";

  /** 到仓件数 */
  toWarehouseQty = undefined;

  /** 到仓时间 */
  toWarehouseTime = "";
}

class CabinFactoryTransferRequestDto {
  /** 工作流实例 */
  activitiApplyRequestDto = new ActivitiApplyRequestDto();

  /** 订舱计划号 */
  crno = "";
}

class CabinLinkAllocationResponseDto {
  /** 调拨单号 */
  aoNoList = [];

  /** 订舱计划号 */
  crNo = "";
}

class CabinMasterDataResponseDto {
  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** 订舱附件 */
  bookingCabinFile = "";

  /** 订舱完成时间 */
  bookingCabinTime = "";

  /** 箱数 */
  boxQty = undefined;

  /** cabinPoDetailDataResponseDto */
  cabinPoDetailDataResponseDto = [];

  /** cabinSkuDetailDataResponseDto */
  cabinSkuDetailDataResponseDto = [];

  /** 是否作废 0否 1是 */
  cancelFlag = undefined;

  /** 作废备注 */
  cancelRemake = "";

  /** centerId */
  centerId = "";

  /** 是否校验CenterId：1是 0否 */
  checkCenterFlag = undefined;

  /** 确认装柜时间 */
  confirmLoadCabinTime = "";

  /** 货柜号 */
  containerNo = "";

  /** 订舱计划号 */
  crno = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前处理人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 发运附件 */
  deliveryFile = "";

  /** 发运时间 */
  deliveryTime = "";

  /** 直发类型: 10 自营调拨/第三方调拨 20 FBA调拨  */
  directType = undefined;

  /** 司机姓名 */
  driverName = "";

  /** 司机电话号码 */
  driverPhone = "";

  /** 截单日期 */
  endBillTime = "";

  /** ETA */
  etaTime = "";

  /** ETD */
  etdTime = "";

  /** 货好日期 */
  goodsFinishTime = "";

  /** id */
  id = undefined;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 最晚订船日期(最后确定装柜时间) */
  latestLoadBoatTime = "";

  /** 最晚装柜日期 */
  latestLoadCabinTime = "";

  /** 车牌信息 */
  licensePlate = "";

  /** 装柜类型: 10 散货,20 20GP,30 40HQ, 40 40GP */
  loadCabinType = undefined;

  /** 渠道服务编号 */
  logisticsChannelCode = "";

  /** 渠道服务名称 */
  logisticsChannelName = "";

  /** 物流员名字 */
  logisticsOwner = "";

  /** 物流员编号 */
  logisticsOwnerCode = "";

  /** 渠道商编号 */
  logisticsProviderCode = "";

  /** 渠道商名称 */
  logisticsProviderName = "";

  /** 物流方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车 */
  logisticsType = undefined;

  /** 提柜时间 */
  pickupCabinTime = "";

  /** 计划出货日期 */
  planShipmentTime = "";

  /** 渠道编号（平台） */
  platformKey = "";

  /** 渠道名字（平台） */
  platformName = "";

  /** 采购负责人 */
  purchaseOwner = "";

  /** 采购负责人编号 */
  purchaseOwnerCode = "";

  /** 总数量 */
  qty = undefined;

  /** 收货联系电话 */
  receivingContactNumber = "";

  /** 收货人 */
  receivingPersonnel = "";

  /** 驳回状态 */
  rejectStatus = undefined;

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回原因 */
  rejectTimeReason = "";

  /** 驳回人 */
  rejector = "";

  /** 备注 */
  remark = "";

  /** 封条号 */
  sealno = "";

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名字 */
  shopName = "";

  /** 站点 */
  site = "";

  /** SO号 */
  soNo = "";

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 起运港地址 */
  startPortAddress = "";

  /** 起运港编号 */
  startPortCode = "";

  /** 起运港名称 */
  startPortName = "";

  /** 状态：10 待提交，20 待采购审核，30 待锁仓，40 待订舱，50 待入库，60 待调拨，70 待提柜，80 待发运，90 已订舱，100 仓库已确认，110 已发运，120 已作废 */
  status = undefined;

  /** 供应商 */
  supplier = "";

  /** 调入交易主体编号 */
  targetTradeCompanyCode = "";

  /** 调入交易主体名称 */
  targetTradeCompanyName = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** TMS单号 */
  tmsno = "";

  /** 到仓地址 */
  toWarehouseAddress = "";

  /** 到仓件数 */
  toWarehouseQty = undefined;

  /** 到仓时间 */
  toWarehouseTime = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 调拨类型: 10 普通调拨,20 FBA调拨,30 三方调拨 */
  transferType = undefined;

  /** 类型：10 工厂整柜，20 工厂散货，30 自营整柜，40 自营散货 */
  type = undefined;

  /** VAT店铺信息 */
  vatShop = "";

  /** 体积 */
  volume = undefined;

  /** 运单号 */
  waybillNo = "";

  /** 重量 */
  weight = undefined;
}

class CabinMasterRequestDto {
  /** 交货单号 */
  dono = "";
}

class CabinMasterResponseDto {
  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** 订舱附件 */
  bookingCabinFile = "";

  /** 订舱完成时间 */
  bookingCabinTime = "";

  /** 箱数 */
  boxQty = undefined;

  /** 是否作废 0否 1是 */
  cancelFlag = undefined;

  /** 作废备注 */
  cancelRemake = "";

  /** centerId */
  centerId = "";

  /** 是否校验CenterId：1是 0否 */
  checkCenterFlag = undefined;

  /** 确认装柜时间 */
  confirmLoadCabinTime = "";

  /** 货柜号 */
  containerNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 订舱计划号 */
  crno = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前处理人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 发运附件 */
  deliveryFile = "";

  /** 发运时间 */
  deliveryTime = "";

  /** 直发类型: 10 自营调拨/第三方调拨 20 FBA调拨  */
  directType = undefined;

  /** 司机姓名 */
  driverName = "";

  /** 司机电话号码 */
  driverPhone = "";

  /** 截单日期 */
  endBillTime = "";

  /** ETA */
  etaTime = "";

  /** ETD */
  etdTime = "";

  /** 第三方附件名称 */
  fileName = "";

  /** 第三方附件url */
  fileUrl = "";

  /** 货好日期 */
  goodsFinishTime = "";

  /** id */
  id = undefined;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 是否入库： 0 否 1 是 */
  isInStock = undefined;

  /** 最晚订船日期(最后确定装柜时间) */
  latestLoadBoatTime = "";

  /** 最晚装柜日期 */
  latestLoadCabinTime = "";

  /** 车牌信息 */
  licensePlate = "";

  /** 装柜类型: 10 散货,20 20GP,30 40HQ, 40 40GP */
  loadCabinType = undefined;

  /** 渠道服务编号 */
  logisticsChannelCode = "";

  /** 渠道服务名称 */
  logisticsChannelName = "";

  /** 物流员 */
  logisticsOwner = "";

  /** 物流员编号 */
  logisticsOwnerCode = "";

  /** 渠道商编号 */
  logisticsProviderCode = "";

  /** 渠道商名称 */
  logisticsProviderName = "";

  /** 物流方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车 */
  logisticsType = undefined;

  /** 提柜时间 */
  pickupCabinTime = "";

  /** 计划需求日期 */
  planNeedTime = "";

  /** 计划出货日期 */
  planShipmentTime = "";

  /** 渠道编号（平台） */
  platformKey = "";

  /** 渠道名字（平台） */
  platformName = "";

  /** PO信息明细 */
  poDetailResponseDtos = [];

  /** 产品标签附件名称 */
  productFileName = "";

  /** 产品标签附件url */
  productFileUrl = "";

  /** 采购负责人 */
  purchaseOwner = "";

  /** 采购负责人编号 */
  purchaseOwnerCode = "";

  /** 总数量 */
  qty = undefined;

  /** 收货联系电话 */
  receivingContactNumber = "";

  /** 收货人 */
  receivingPersonnel = "";

  /** 驳回状态 */
  rejectStatus = undefined;

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回原因 */
  rejectTimeReason = "";

  /** 驳回人 */
  rejector = "";

  /** 备注 */
  remake = "";

  /** 备注 */
  remark = "";

  /** 封条号 */
  sealno = "";

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名字 */
  shopName = "";

  /** 站点 */
  site = "";

  /** SKU信息明细 */
  skuDetailResponseDtos = [];

  /** SO号 */
  soNo = "";

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 起运港 */
  startPort = "";

  /** 起运港地址 */
  startPortAddress = "";

  /** 起运港编号 */
  startPortCode = "";

  /** 起运港名称 */
  startPortName = "";

  /** 状态：10 待提交，20 待采购审核，30 待锁仓，40 待订舱，50 待入库，60 待调拨，70 待提柜，80 待发运，90 已订舱，100 仓库已确认，110 已发运，120 已作废 */
  status = undefined;

  /** 供应商 */
  supplier = "";

  /** 供应商code */
  supplierCode = "";

  /** 调入交易主体编号 */
  targetTradeCompanyCode = "";

  /** 调入交易主体名称 */
  targetTradeCompanyName = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** TMS单号 */
  tmsno = "";

  /** TO信息明细 */
  toDetailResponseDtos = [];

  /** 到仓地址 */
  toWarehouseAddress = "";

  /** 到仓件数 */
  toWarehouseQty = undefined;

  /** 到仓时间 */
  toWarehouseTime = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 拖车代理 */
  trailerAgent = "";

  /** 拖车代理编码 */
  trailerAgentCode = "";

  /** 调拨类型: 10 普通调拨,20 FBA调拨,30 三方调拨 */
  transferType = undefined;

  /** 类型：10 工厂整柜，20 工厂散货，30 自营整柜，40 自营散货 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** VAT店铺信息 */
  vatShop = "";

  /** 供应商内部代码 */
  vendorInternalCode = "";

  /** 体积 */
  volume = undefined;

  /** 运单号 */
  waybillNo = "";

  /** 重量 */
  weight = undefined;
}

class CabinPoDetailDataResponseDto {
  /** 订舱计划号 */
  crno = "";

  /** 交货单号 */
  dono = "";

  /** id */
  id = undefined;

  /** 采购单号 */
  pono = "";

  /** 数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** sku */
  sku = "";

  /** 供应商 */
  supplier = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class CabinPoDetailRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 订舱计划号 */
  crno = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 交货单号 */
  dono = "";

  /** id */
  id = undefined;

  /** 采购单号 */
  pono = "";

  /** 数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** 退货单号 */
  rono = "";

  /** 行号 */
  rowNo = undefined;

  /** sku */
  sku = "";

  /** 供应商 */
  supplier = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class CabinPoDetailResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 订舱计划号 */
  crno = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 交货单号 */
  dono = "";

  /** id */
  id = undefined;

  /** 采购单号 */
  pono = "";

  /** 数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** 退货单号 */
  rono = "";

  /** 行号 */
  rowNo = undefined;

  /** sku */
  sku = "";

  /** 供应商 */
  supplier = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class CabinSelfCreateRequestDto {
  /** 订柜数量 */
  cabinNum = undefined;

  /** centerId */
  centerId = "";

  /** 订舱计划号 */
  crno = "";

  /** 装柜类型: 10 散货,20 20GP,30 40HQ, 40 40GP */
  loadCabinType = undefined;

  /** 物流方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车 */
  logisticsType = undefined;

  /** 计划出货日期 */
  planShipmentTime = "";

  /** 站点 */
  site = "";

  /** SKU明细 */
  skuDetailRequestDtos = [];

  /** 状态：10 待提交，40 待订舱 */
  status = undefined;

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 调拨类型: 10 普通调拨,20 FBA调拨,30 三方调拨 */
  transferType = undefined;

  /** VAT店铺信息 */
  vatShop = "";
}

class CabinSelfReserveCabinRequestDto {
  /** 工作流实例 */
  activitiApplyRequestDto = new ActivitiApplyRequestDto();

  /** 订舱附件 */
  bookingCabinFile = "";

  /** 订舱完成时间 */
  bookingCabinTime = "";

  /** 货柜号 */
  containerNo = "";

  /** 订舱计划号 */
  crno = "";

  /** 司机姓名 */
  driverName = "";

  /** 司机电话号码 */
  driverPhone = "";

  /** 截单日期 */
  endBillTime = "";

  /** ETA */
  etaTime = "";

  /** ETD */
  etdTime = "";

  /** 最晚装柜日期 */
  latestLoadCabinTime = "";

  /** 车牌信息 */
  licensePlate = "";

  /** 渠道服务编号 */
  logisticsChannelCode = "";

  /** 渠道服务名称 */
  logisticsChannelName = "";

  /** 渠道商编号 */
  logisticsProviderCode = "";

  /** 渠道商名称 */
  logisticsProviderName = "";

  /** 提柜时间 */
  pickupCabinTime = "";

  /** 封条号 */
  sealno = "";

  /** SO号 */
  soNo = "";

  /** 起运港地址 */
  startPortAddress = "";

  /** 起运港编号 */
  startPortCode = "";

  /** 起运港名称 */
  startPortName = "";

  /** 拖车代理 */
  trailerAgent = "";

  /** 拖车代理编码 */
  trailerAgentCode = "";

  /** 供应商内部代码 */
  vendorInternalCode = "";

  /** 物流单号 */
  waybillNo = "";
}

class CabinSelfWarehouseExamineRequestDto {
  /** 工作流实例 */
  activitiApplyRequestDto = new ActivitiApplyRequestDto();

  /** 是否校验CenterId：1是 0否 */
  checkCenterFlag = undefined;

  /** 确认装柜时间/确认到仓时间 */
  confirmLoadCabinTime = "";

  /** 订舱计划号 */
  crno = "";

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";
}

class CabinSkuDetailDataResponseDtoReq {
  /** sku */
  sku = "";

  /** 供应商编码 */
  supplierCode = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";
}

class CabinSkuDetailDataResponseDtoRes {
  /** 预装柜总体积（m³） */
  advanceVolume = undefined;

  /** 预装柜总毛重（kg） */
  advanceWeight = undefined;

  /** asin */
  asin = "";

  /** 箱数 */
  boxQty = undefined;

  /** BU编码 */
  buCode = "";

  /** BU名称 */
  buName = "";

  /** centerId */
  centerId = "";

  /** 订舱计划号 */
  crno = "";

  /** fnsku */
  fnsku = "";

  /** 20GP柜型占比 */
  gpProportion = undefined;

  /** 高 */
  heightCm = undefined;

  /** 40HQ柜型占比 */
  hqProportion = undefined;

  /** id */
  id = undefined;

  /** 装柜地址 */
  loadCabinAddress = "";

  /** 装柜属性: 10标准件 20大件 30超大件 */
  loadCabinAttribute = undefined;

  /** 长 */
  longCm = undefined;

  /** mpq */
  mpq = undefined;

  /** MSKU */
  msku = "";

  /** 采购单号 */
  pono = "";

  /** SKU中文标题 */
  productSkuName = "";

  /** 数量 */
  qty = undefined;

  /** referenceId */
  referenceId = "";

  /** 备注 */
  remark = "";

  /** shipment */
  shipment = "";

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名字 */
  shopName = "";

  /** 单箱体积 */
  singleVolume = undefined;

  /** 单个重量 */
  singleWeight = undefined;

  /** sku */
  sku = "";

  /** 供应商 */
  supplier = "";

  /** 供应商名称 */
  supplierName = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名字 */
  targetWarehouseName = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 体积 */
  volume = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 重量 */
  weight = undefined;

  /** 宽 */
  widthCm = undefined;
}

class CabinSkuDetailRequestDto {
  /** 预装柜总体积（m³） */
  advanceVolume = undefined;

  /** 预装柜总毛重（kg） */
  advanceWeight = undefined;

  /** asin */
  asin = "";

  /** 箱数 */
  boxQty = undefined;

  /** BU编码 */
  buCode = "";

  /** BU名称 */
  buName = "";

  /** centerId */
  centerId = "";

  /** 订舱计划号 */
  crno = "";

  /** fnsku */
  fnsku = "";

  /** 20GP柜型占比 */
  gpProportion = undefined;

  /** 高 */
  heightCm = undefined;

  /** 40HQ柜型占比 */
  hqProportion = undefined;

  /** id */
  id = undefined;

  /** 装柜地址 */
  loadCabinAddress = "";

  /** 装柜属性: 10标准件 20大件 30超大件 */
  loadCabinAttribute = undefined;

  /** 长 */
  longCm = undefined;

  /** mpq */
  mpq = undefined;

  /** MSKU */
  msku = "";

  /** 采购单号 */
  pono = "";

  /** SKU中文标题 */
  productSkuName = "";

  /** SKU英文标题 */
  productSkuNameEn = "";

  /** 数量 */
  qty = undefined;

  /** referenceId */
  referenceId = "";

  /** 备注 */
  remark = "";

  /** shipment */
  shipment = "";

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名 */
  shopName = "";

  /** 单箱体积 */
  singleVolume = undefined;

  /** 单个重量 */
  singleWeight = undefined;

  /** sku */
  sku = "";

  /** 来源渠道key */
  sourceChannelKey = "";

  /** 来源渠道名称 */
  sourceChannelName = "";

  /** 供应商 */
  supplier = "";

  /** 供应商code */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 目标渠道key */
  targetChannelKey = "";

  /** 目标渠道名称 */
  targetChannelName = "";

  /** 调入交易主体编号 */
  targetTradeCompanyCode = "";

  /** 调入交易主体名称 */
  targetTradeCompanyName = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 体积 */
  volume = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 重量 */
  weight = undefined;

  /** 宽 */
  widthCm = undefined;
}

class CabinSkuDetailResponseDto {
  /** 预装柜总体积（m³） */
  advanceVolume = undefined;

  /** 预装柜总毛重（kg） */
  advanceWeight = undefined;

  /** asin */
  asin = "";

  /** 箱数 */
  boxQty = undefined;

  /** BU编码 */
  buCode = "";

  /** BU名称 */
  buName = "";

  /** centerId */
  centerId = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 订舱计划号 */
  crno = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** fnsku */
  fnsku = "";

  /** 20GP柜型占比 */
  gpProportion = undefined;

  /** 高 */
  heightCm = undefined;

  /** 40HQ柜型占比 */
  hqProportion = undefined;

  /** id */
  id = undefined;

  /** 装柜地址 */
  loadCabinAddress = "";

  /** 装柜属性: 10标准件 20大件 30超大件 */
  loadCabinAttribute = undefined;

  /** 长 */
  longCm = undefined;

  /** mpq */
  mpq = undefined;

  /** MSKU */
  msku = "";

  /** 采购单号 */
  pono = "";

  /** SKU中文标题 */
  productSkuName = "";

  /** SKU英文标题 */
  productSkuNameEn = "";

  /** 数量 */
  qty = undefined;

  /** referenceId */
  referenceId = "";

  /** 备注 */
  remark = "";

  /** shipment */
  shipment = "";

  /** shopCode */
  shopCode = "";

  /** shopName */
  shopName = "";

  /** 单箱体积 */
  singleVolume = undefined;

  /** 单个重量 */
  singleWeight = undefined;

  /** sku */
  sku = "";

  /** 来源渠道key */
  sourceChannelKey = "";

  /** 来源渠道名称 */
  sourceChannelName = "";

  /** 供应商 */
  supplier = "";

  /** 供应商code */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 目标渠道key */
  targetChannelKey = "";

  /** 目标渠道名称 */
  targetChannelName = "";

  /** 调入交易主体编号 */
  targetTradeCompanyCode = "";

  /** 调入交易主体名称 */
  targetTradeCompanyName = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 体积 */
  volume = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 重量 */
  weight = undefined;

  /** 宽 */
  widthCm = undefined;
}

class CabinToDetailDataResponseDto {
  /** 调拨单号 */
  aono = "";

  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** 订舱附件 */
  bookingCabinFile = "";

  /** 订舱完成时间 */
  bookingCabinTime = "";

  /** 箱数 */
  boxQty = undefined;

  /** cabinPoDetailDataResponseDto */
  cabinPoDetailDataResponseDto = [];

  /** cabinSkuDetailDataResponseDto */
  cabinSkuDetailDataResponseDto = [];

  /** 是否作废 0否 1是 */
  cancelFlag = undefined;

  /** 作废备注 */
  cancelRemake = "";

  /** centerId */
  centerId = "";

  /** 是否校验CenterId：1是 0否 */
  checkCenterFlag = undefined;

  /** 确认装柜时间 */
  confirmLoadCabinTime = "";

  /** 货柜号 */
  containerNo = "";

  /** 订舱计划号 */
  crno = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前处理人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 发运附件 */
  deliveryFile = "";

  /** 发运时间 */
  deliveryTime = "";

  /** 直发类型: 10 自营调拨/第三方调拨 20 FBA调拨  */
  directType = undefined;

  /** 司机姓名 */
  driverName = "";

  /** 司机电话号码 */
  driverPhone = "";

  /** 截单日期 */
  endBillTime = "";

  /** ETA */
  etaTime = "";

  /** ETD */
  etdTime = "";

  /** 货好日期 */
  goodsFinishTime = "";

  /** id */
  id = undefined;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 最晚订船日期(最后确定装柜时间) */
  latestLoadBoatTime = "";

  /** 最晚装柜日期 */
  latestLoadCabinTime = "";

  /** 车牌信息 */
  licensePlate = "";

  /** 装柜类型: 10 散货,20 20GP,30 40HQ, 40 40GP */
  loadCabinType = undefined;

  /** 渠道服务编号 */
  logisticsChannelCode = "";

  /** 渠道服务名称 */
  logisticsChannelName = "";

  /** 物流员名字 */
  logisticsOwner = "";

  /** 物流员编号 */
  logisticsOwnerCode = "";

  /** 渠道商编号 */
  logisticsProviderCode = "";

  /** 渠道商名称 */
  logisticsProviderName = "";

  /** 物流方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车 */
  logisticsType = undefined;

  /** 提柜时间 */
  pickupCabinTime = "";

  /** 计划出货日期 */
  planShipmentTime = "";

  /** 渠道编号（平台） */
  platformKey = "";

  /** 渠道名字（平台） */
  platformName = "";

  /** 采购负责人 */
  purchaseOwner = "";

  /** 采购负责人编号 */
  purchaseOwnerCode = "";

  /** 总数量 */
  qty = undefined;

  /** 收货联系电话 */
  receivingContactNumber = "";

  /** 收货人 */
  receivingPersonnel = "";

  /** 驳回状态 */
  rejectStatus = undefined;

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回原因 */
  rejectTimeReason = "";

  /** 驳回人 */
  rejector = "";

  /** 备注 */
  remark = "";

  /** 封条号 */
  sealno = "";

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名字 */
  shopName = "";

  /** 站点 */
  site = "";

  /** SO号 */
  soNo = "";

  /** 来源仓库编号 */
  sourceWarehouseCode = "";

  /** 来源仓库名称 */
  sourceWarehouseName = "";

  /** 起运港地址 */
  startPortAddress = "";

  /** 起运港编号 */
  startPortCode = "";

  /** 起运港名称 */
  startPortName = "";

  /** 状态：10 待提交，20 待采购审核，30 待锁仓，40 待订舱，50 待入库，60 待调拨，70 待提柜，80 待发运，90 已订舱，100 仓库已确认，110 已发运，120 已作废 */
  status = undefined;

  /** 供应商 */
  supplier = "";

  /** 调入交易主体编号 */
  targetTradeCompanyCode = "";

  /** 调入交易主体名称 */
  targetTradeCompanyName = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** TMS单号 */
  tmsno = "";

  /** 到仓地址 */
  toWarehouseAddress = "";

  /** 到仓件数 */
  toWarehouseQty = undefined;

  /** 到仓时间 */
  toWarehouseTime = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 调拨类型: 10 普通调拨,20 FBA调拨,30 三方调拨 */
  transferType = undefined;

  /** 类型：10 工厂整柜，20 工厂散货，30 自营整柜，40 自营散货 */
  type = undefined;

  /** VAT店铺信息 */
  vatShop = "";

  /** 体积 */
  volume = undefined;

  /** 运单号 */
  waybillNo = "";

  /** 重量 */
  weight = undefined;
}

class CabinToDetailRequestDto {
  /** 调拨单号 */
  aono = "";

  /** 箱数 */
  boxQty = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 订舱计划号 */
  crno = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 渠道编号 */
  platformKey = "";

  /** 渠道名字 */
  platformName = "";

  /** 总数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** shipment */
  shipment = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 体积 */
  volume = undefined;

  /** 重量 */
  weight = undefined;
}

class CabinToDetailResponseDto {
  /** 调拨单号 */
  aono = "";

  /** 箱数 */
  boxQty = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 订舱计划号 */
  crno = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 渠道编号 */
  platformKey = "";

  /** 渠道名字 */
  platformName = "";

  /** 总数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** shipment */
  shipment = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 体积 */
  volume = undefined;

  /** 重量 */
  weight = undefined;
}

class CashFlowRequestParamsDto {
  /** 现金流量表项 */
  cashFlow = "";

  /** 现金流量表项id */
  cfId = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0：否 1：是 */
  deleted = undefined;

  /** 10:流入 20：流出 */
  flowStatus = undefined;

  /** id */
  id = undefined;

  /** 10：经营 20：投资 30：筹资 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class CashFlowResponseDto {
  /** 现金流量表项 */
  cashFlow = "";

  /** 现金流量表项id */
  cfId = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0：否 1：是 */
  deleted = undefined;

  /** 10:流入 20：流出 */
  flowStatus = undefined;

  /** id */
  id = undefined;

  /** 10：经营 20：投资 30：筹资 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class CbsPaymentResponseDto {
  /** 业务单据号 */
  businessDocumentNumber = "";

  /** 业务参考号 */
  businessReferenceNumber = "";

  /** CBS单据号 */
  cbsDocumentNumber = "";

  /** CBS付款状态 */
  cbsPaymentStatus = "";

  /** CBS付款时间 */
  cbsPaymentTime = "";

  /** CBS水单附件 */
  cbsReceiptAttachment = "";

  /** 备注 */
  remark = "";
}

class CostRequestReportRequestDto {
  /** advanceFlag */
  advanceFlag = undefined;

  /** billingUnit */
  billingUnit = "";

  /** costName */
  costName = "";

  /** currency */
  currency = "";

  /** errorMsg */
  errorMsg = "";

  /** estimateAmount */
  estimateAmount = undefined;

  /** payeeName */
  payeeName = "";

  /** payerCompanyName */
  payerCompanyName = "";

  /** price */
  price = undefined;

  /** qty */
  qty = undefined;

  /** remark */
  remark = "";

  /** 是否重复数据 */
  repeatFlag = undefined;

  /** rowNum */
  rowNum = undefined;

  /** tmsno */
  tmsno = "";

  /** vendorInternalCode */
  vendorInternalCode = "";

  /** waybillNo */
  waybillNo = "";
}

class CostRequestRequestDto {
  /** 是否预付款：1是 0否 */
  advanceFlag = undefined;

  /** 总金额 */
  amount = undefined;

  /** 请款时间 */
  applyTime = "";

  /** 单据序列号 */
  billSerialNo = "";

  /** 计费单位 */
  billingUnit = "";

  /** 现金流量表项 */
  cashFlow = "";

  /** 现金流量表项id */
  cfId = "";

  /** 费用编号 */
  costCode = "";

  /** 费用名称 */
  costName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 预估总金额 */
  estimateAmount = undefined;

  /** 汇率 */
  exchangeRate = undefined;

  /** id */
  id = undefined;

  /** 日记账科目 */
  journalSubject = "";

  /** 收款方编号 */
  payeeCode = "";

  /** 收款方名称 */
  payeeName = "";

  /** 付款方主体编号 */
  payerCompanyCode = "";

  /** 付款方主体名称 */
  payerCompanyName = "";

  /** 付款单号 */
  payno = "";

  /** 单价 */
  price = undefined;

  /** 数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** 状态：10 待请款，20 请款审批中，30 部分付款，40 已付款 */
  status = undefined;

  /** TMS单号 */
  tmsno = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 供应商内部代码 */
  vendorInternalCode = "";

  /** 物流单号 */
  waybillNo = "";
}

class CostRequestRequestParamsDto {
  /** 是否预付款：1是 0否 */
  advanceFlag = undefined;

  /** 总金额 */
  amount = undefined;

  /** TO单号 */
  aoNo = "";

  /** 请款时间 */
  applyTime = "";

  /** 出货时间-结束 */
  arriveWarehouseTimeEnd = "";

  /** 出货时间-开始 */
  arriveWarehouseTimeStart = "";

  /** 单据序列号 */
  billSerialNo = "";

  /** 计费单位 */
  billingUnit = "";

  /** 现金流量表项 */
  cashFlow = "";

  /** 现金流量表项id */
  cfId = "";

  /** 货柜号 */
  containerNo = "";

  /** 费用编号 */
  costCode = "";

  /** 费用名称 */
  costName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 预估总金额 */
  estimateAmount = undefined;

  /** 汇率 */
  exchangeRate = undefined;

  /** 到港时间-结束 */
  extractTimeEnd = "";

  /** 到港时间-开始 */
  extractTimeStart = "";

  /** id */
  id = undefined;

  /** ids */
  ids = "";

  /** 日记账科目 */
  journalSubject = "";

  /** 收款方编号 */
  payeeCode = "";

  /** 收款方名称 */
  payeeName = "";

  /** 付款方主体编号 */
  payerCompanyCode = "";

  /** 付款方主体名称 */
  payerCompanyName = "";

  /** 付款单号 */
  payno = "";

  /** 签收时间-结束 */
  podSignTimeEnd = "";

  /** 签收时间-开始 */
  podSignTimeStart = "";

  /** 单价 */
  price = undefined;

  /** 数量 */
  qty = undefined;

  /** 开船时间-结束 */
  releaseTimeEnd = "";

  /** 开船时间-开始 */
  releaseTimeStart = "";

  /** 备注 */
  remark = "";

  /** SO号 */
  soNo = "";

  /** 状态：10 待请款，20 请款审批中，30 部分付款，40 已付款 */
  status = undefined;

  /** 订单状态多选，英文逗号分隔 */
  statusIn = "";

  /** TMS单号 */
  tmsno = "";

  /** TMS单号多选，英文逗号分隔 */
  tmsnoIn = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 供应商内部代码 */
  vendorInternalCode = "";

  /** 物流单号 */
  waybillNo = "";
}

class CostRequestResponseDto {
  /** 是否预付款：1是 0否 */
  advanceFlag = undefined;

  /** 总金额 */
  amount = undefined;

  /** 请款时间 */
  applyTime = "";

  /** 单据序列号 */
  billSerialNo = "";

  /** 计费单位 */
  billingUnit = "";

  /** 现金流量表项 */
  cashFlow = "";

  /** 现金流量表项id */
  cfId = "";

  /** 费用编号 */
  costCode = "";

  /** 费用名称 */
  costName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 预估总金额 */
  estimateAmount = undefined;

  /** 汇率 */
  exchangeRate = undefined;

  /** id */
  id = undefined;

  /** 日记账科目 */
  journalSubject = "";

  /** 收款方编号 */
  payeeCode = "";

  /** 收款方名称 */
  payeeName = "";

  /** 付款方主体编号 */
  payerCompanyCode = "";

  /** 付款方主体名称 */
  payerCompanyName = "";

  /** 付款单号 */
  payno = "";

  /** 单价 */
  price = undefined;

  /** 数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** 状态：10 待请款，20 请款审批中，30 部分付款，40 已付款 */
  status = undefined;

  /** TMS单号/物流单号 */
  tmsno = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 供应商内部代码 */
  vendorInternalCode = "";

  /** 运单号 */
  waybillNo = "";
}

class CostRequestUpdateDto {
  /** 是否预付款：1是 0否 */
  advanceFlag = undefined;

  /** 总金额 */
  amount = undefined;

  /** 计费单位 */
  billingUnit = "";

  /** 费用编号 */
  costCode = "";

  /** 费用名称 */
  costName = "";

  /** 币种 */
  currency = "";

  /** 预估总金额 */
  estimateAmount = undefined;

  /** id */
  id = undefined;

  /** 收款方编号 */
  payeeCode = "";

  /** 收款方名称 */
  payeeName = "";

  /** 付款方主体编号 */
  payerCompanyCode = "";

  /** 付款方主体名称 */
  payerCompanyName = "";

  /** 单价 */
  price = undefined;

  /** 数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** TMS单号 */
  tmsno = "";

  /** 物流单号 */
  waybillNo = "";
}

class CostToPayRequestDto {
  /** 费用请款列表 */
  costList = [];

  /** 汇率 */
  exchangeRate = undefined;

  /** 是否国内银行 0:否 1:是 */
  isDomesticBank = undefined;

  /** 收款账户名称 */
  payeeAccountName = "";

  /** 收款银行 */
  payeeBankName = "";

  /** 收款账户 */
  payeeBankNumber = "";

  /** 用途 */
  purpose = "";

  /** 收款账户名 */
  recipientAccountName = "";

  /** 收款账号 */
  recipientAccountNumber = "";

  /** 收款开户市 */
  recipientBankCity = "";

  /** 收款银行名称 */
  recipientBankName = "";

  /** 收款开户省 */
  recipientBankProvince = "";

  /** 收款开户行 */
  recipientOpeningBankName = "";

  /** 备注 */
  remark = "";

  /** 请款附件 */
  requestFile = "";

  /** 供应商内部代码 */
  vendorInternalCode = "";
}

class CostTypeRequestDto {
  /** 现金流量表项 */
  cashFlow = "";

  /** 现金流量表项id */
  cfId = "";

  /** 费用编号 */
  costCode = "";

  /** 费用名称 */
  costName = "";

  /** id */
  id = undefined;

  /** 日记账科目 */
  journalSubject = "";
}

class CostTypeResponseDto {
  /** 现金流量表项 */
  cashFlow = "";

  /** 现金流量表项id */
  cfId = "";

  /** 费用编号 */
  costCode = "";

  /** 费用名称 */
  costName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 日记账科目 */
  journalSubject = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class CountryResponseDto {
  /** 大洲 */
  continent = "";

  /** 中文名称 */
  countryNameCn = "";

  /** 英文名称 */
  countryNameEn = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 数字码 */
  digitalCode = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 二字码 */
  secondWord = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 三字码 */
  threeWord = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class CurrentTaskDto {
  /** 节点当前处理人 */
  currentAssignee = new AssigneeDto();

  /** 节点编码 */
  nodeKey = "";

  /** 节点名称 */
  nodeName = "";

  /** 节点操作类型 驳回指定节点:backToStart；驳回:reject；通过:pass,；反对：oppose；弃权：abandon；终止：cadence */
  operate = "";

  /** 任务id */
  taskId = "";
}

class CustomDeclarationResponseRpcDto {
  /** 采购订单号 */
  pono = "";

  /** 报关数量 */
  qty = undefined;

  /** 订单行号 */
  rowNo = undefined;

  /** sku */
  sku = "";
}

class CustomsClearanceDSHRequestDto {
  /** 审核意见 */
  approvalComments = "";

  /** 审核状态 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** 来源单号 */
  sourceNo = "";
}

class CustomsClearanceDetailReportExcelResponseDto {
  /** BO单号 */
  boNo = "";

  /** 报关合同号 */
  contractNo = "";

  /** 报关单号 */
  customsDeclarationNo = "";

  /** 申报单价 */
  declareDollarPrice = undefined;

  /** 品名 */
  declareName = "";

  /** 国家 */
  destinationCountry = "";

  /** 进项税额 */
  differencePrice = undefined;

  /** 换汇成本 */
  exchangeCost = undefined;

  /** 申报汇率 */
  exchangeRate = undefined;

  /** 采购含税金额 */
  hsAmount = undefined;

  /** id */
  id = undefined;

  /** PO号 */
  pono = "";

  /** 采购含税单价 */
  price = undefined;

  /** 数量 */
  qty = undefined;

  /** 行号 */
  rowNo = undefined;

  /** SKU */
  sku = "";

  /** 包裹单号 */
  sourceNo = "";

  /** 报关明细号 */
  subContractNo = "";

  /** 供应商 */
  supplierIdName = "";

  /** 税率 */
  taxRate = undefined;

  /** 申报总价 */
  totalDollarPrice = undefined;

  /** 主体 */
  tradeCompanyName = "";

  /** 运输方式 */
  transportType = "";

  /** 采购不含税金额 */
  unHsAmount = undefined;

  /** 采购不含税单价 */
  unHsPrice = undefined;

  /** 单位 */
  unitName = "";
}

class CustomsClearanceDetailsRequestDto {
  /** 品牌 */
  brandName = "";

  /** 是否商检 */
  commodityInspectionFlag = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 申报要素 */
  declareMemo = "";

  /** 品名 */
  declareName = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 毛重 */
  grossWeight = undefined;

  /** id */
  id = undefined;

  /** 型号 */
  model = "";

  /** mpq */
  mpq = undefined;

  /** 净重 */
  netWeight = undefined;

  /** 父ID */
  parentId = undefined;

  /** po单号 */
  pono = "";

  /** 含税单价 */
  price = undefined;

  /** 商品编号 */
  productNumber = "";

  /** 数量 */
  qty = undefined;

  /** 行号 */
  rowNo = undefined;

  /** sku */
  sku = "";

  /** 境内货源地 */
  sourceGoods = "";

  /** 子合同号 */
  subContractNo = "";

  /** 供应商id */
  supplierIdName = "";

  /** 单位 */
  unitName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class CustomsClearanceDetailsResponseDto {
  /** 件数(箱数) */
  boxQty = undefined;

  /** 品牌 */
  brandName = "";

  /** 是否商检 */
  commodityInspectionFlag = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 申报要素 */
  declareMemo = "";

  /** 品名 */
  declareName = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 毛重 */
  grossWeight = undefined;

  /** id */
  id = undefined;

  /** 型号 */
  model = "";

  /** mpq */
  mpq = undefined;

  /** 净重 */
  netWeight = undefined;

  /** 父ID */
  parentId = undefined;

  /** po单号 */
  pono = "";

  /** 含税单价 */
  price = undefined;

  /** 商品编号 */
  productNumber = "";

  /** 数量 */
  qty = undefined;

  /** 行号 */
  rowNo = undefined;

  /** sku */
  sku = "";

  /** 境内货源地 */
  sourceGoods = "";

  /** 子合同号 */
  subContractNo = "";

  /** 供应商id */
  supplierIdName = "";

  /** 单位 */
  unitName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class CustomsClearanceDownloadResponseDto {
  /** 出口报关附件 */
  exportDeclarationFiles = [];

  /** 提单附件 */
  ladingFiles = [];
}

class CustomsClearanceRequestDto {
  /** BO单号 */
  boNo = "";

  /** 是否查验 */
  checkFlag = undefined;

  /** 合同号 */
  contractNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币制 */
  currencySystem = "";

  /** 报关员 */
  customsBroker = "";

  /** 报关单号 */
  customsDeclarationNo = "";

  /** 申报日期 */
  declarationTime = "";

  /** 报关代理 */
  declareAgent = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 目的国 */
  destinationCountry = "";

  /** 境内发货人 */
  domesticSender = "";

  /** 截单日期 */
  endBillTime = "";

  /** 汇率 */
  exchangeRate = undefined;

  /** 出口报关时间 */
  exportDeclarationTime = "";

  /** 境外收货人 */
  foreignReceiver = "";

  /** id */
  id = undefined;

  /** 上传提单附件时间 */
  ladingTime = "";

  /** 包装种类 */
  packingType = "";

  /** 备注 */
  remark = "";

  /** 来源单号 */
  sourceNo = "";

  /** 状态：10 企业报关 */
  sourceType = undefined;

  /** 状态：10 待处理，20 已处理，30 已核对，40 已放行，50 待审核，60 驳回，70 已完成，80 已作废 */
  status = undefined;

  /** 总件数 */
  totalNumber = undefined;

  /** 总体积 */
  totalVolume = undefined;

  /** 总重量 */
  totalWeight = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 运输方式  */
  transportType = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class CustomsClearanceRequestParamsDto {
  /** BO单号 */
  boNo = "";

  /** 是否查验 */
  checkFlag = undefined;

  /** 合同号 */
  contractNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币制 */
  currencySystem = "";

  /** 报关员 */
  customsBroker = "";

  /** 报关单号 */
  customsDeclarationNo = "";

  /** 申报日期 */
  declarationTime = "";

  /** 申报日期-结束 */
  declarationTimeEnd = "";

  /** 申报日期-开始 */
  declarationTimeStart = "";

  /** 报关代理 */
  declareAgent = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 目的国 */
  destinationCountry = "";

  /** 境内发货人 */
  domesticSender = "";

  /** 截单日期 */
  endBillTime = "";

  /** 汇率 */
  exchangeRate = undefined;

  /** 出口报关时间 */
  exportDeclarationTime = "";

  /** 出口报关附件上传时间-结束 */
  exportDeclarationTimeEnd = "";

  /** 出口报关附件上传时间-开始 */
  exportDeclarationTimeStart = "";

  /** 境外收货人 */
  foreignReceiver = "";

  /** id */
  id = undefined;

  /** 提单附件 */
  ladingFile = "";

  /** 是否上传提单附件 */
  ladingFileFlag = undefined;

  /** 上传提单附件时间 */
  ladingTime = "";

  /** 提单附件上传时间-结束 */
  ladingTimeEnd = "";

  /** 提单附件上传时间-开始 */
  ladingTimeStart = "";

  /** 包装种类 */
  packingType = "";

  /** 备注 */
  remark = "";

  /** 来源单号 */
  sourceNo = "";

  /** 状态：10 企业报关 */
  sourceType = undefined;

  /** 状态：10 待处理，20 已处理，30 已核对，40 已放行，50 待审核，60 驳回，70 已完成，80 已作废 */
  status = undefined;

  /** 订单状态多选，英文逗号分隔 */
  statusIn = "";

  /** 总件数 */
  totalNumber = undefined;

  /** 总体积 */
  totalVolume = undefined;

  /** 总重量 */
  totalWeight = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 运输方式  */
  transportType = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class CustomsClearanceResponseDto {
  /** BO单号 */
  boNo = "";

  /** 是否查验 */
  checkFlag = undefined;

  /** 是否商检 */
  commodityInspectionFlag = undefined;

  /** 合同号 */
  contractNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币制 */
  currencySystem = "";

  /** 报关员 */
  customsBroker = "";

  /** 报关明细 */
  customsClearanceDetailsResponseDtoList = [];

  /** 出口报关附件 */
  customsClearanceFile = "";

  /** 报关单号 */
  customsDeclarationNo = "";

  /** 申报日期 */
  declarationTime = "";

  /** 报关代理 */
  declareAgent = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 目的国 */
  destinationCountry = "";

  /** 境内发货人 */
  domesticSender = "";

  /** 截单日期 */
  endBillTime = "";

  /** 汇率 */
  exchangeRate = undefined;

  /** 征免性质 */
  exemptionNature = "";

  /** 出口报关时间 */
  exportDeclarationTime = "";

  /** 境外收货人 */
  foreignReceiver = "";

  /** id */
  id = undefined;

  /** 提单附件 */
  ladingBillFile = "";

  /** 上传提单附件时间 */
  ladingTime = "";

  /** 包装种类 */
  packingType = "";

  /** 备注 */
  remark = "";

  /** 来源单号 */
  sourceNo = "";

  /** 状态：10 企业报关 */
  sourceType = undefined;

  /** 状态：10 待处理，20 已处理，30 已核对，40 已放行，50 待审核，60 驳回，70 已完成，80 已作废 */
  status = undefined;

  /** 监管方式 */
  supervisionWay = "";

  /** 总件数 */
  totalNumber = undefined;

  /** 总体积 */
  totalVolume = undefined;

  /** 总重量 */
  totalWeight = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 运输方式  */
  transportType = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class CustomsClearanceYFXRequestDto {
  /** 提单附件 */
  ladingFile = "";

  /** 来源单号 */
  sourceNo = "";
}

class CustomsClearanceYHDRequestDto {
  /** 是否查验 */
  checkFlag = undefined;

  /** 合同号 */
  contractNo = "";

  /** 出口报关附件 */
  customsClearanceFile = "";

  /** 报关单号 */
  customsDeclarationNo = "";

  /** 申报日期 */
  declarationTime = "";

  /** ID */
  id = "";

  /** 提单附件 */
  ladingFile = "";

  /** 来源单号 */
  sourceNo = "";
}

class CustomsDeclarationApplyDetailsRequestDto {
  /** 报关批次号 已处理状态下才有值，表示已经被勾选创建报关单 */
  cbNo = "";

  /** 集装箱号 */
  containerNo = "";

  /** 贸易国 */
  countryName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 报关代理 */
  declareAgent = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 截单日期 */
  endBillTime = "";

  /** 境外收货人 */
  foreignReceiver = "";

  /** id */
  id = undefined;

  /** 渠道服务编号 */
  logisticsChannelCode = "";

  /** 渠道服务名称 */
  logisticsChannelName = "";

  /** 渠道商编号 */
  logisticsProviderCode = "";

  /** 渠道商名称 */
  logisticsProviderName = "";

  /** 物流方式,数据字典： */
  logisticsType = undefined;

  /** 参考单号 */
  referenceNo = "";

  /** 来源单号 */
  sourceNo = "";

  /** 状态：10：待处理 20：已处理 30：已作废 */
  status = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 贸易术语 */
  tradeTerms = "";

  /** 报关类型：10：内部调拨 20：销售订单 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 整柜标识：0：否 1：是 */
  wholeCabinetFlag = undefined;
}

class CustomsDeclarationApplyDetailsResponseDto {
  /** 箱数 */
  boxQty = undefined;

  /** 报关批次号 已处理状态下才有值，表示已经被勾选创建报关单 */
  cbNo = "";

  /** 集装箱号 */
  containerNo = "";

  /** 贸易国 */
  countryName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 报关代理 */
  declareAgent = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 截单日期 */
  endBillTime = "";

  /** 境外收货人 */
  foreignReceiver = "";

  /** id */
  id = undefined;

  /** 渠道服务编号 */
  logisticsChannelCode = "";

  /** 渠道服务名称 */
  logisticsChannelName = "";

  /** 渠道商编号 */
  logisticsProviderCode = "";

  /** 渠道商名称 */
  logisticsProviderName = "";

  /** 物流方式,数据字典： */
  logisticsType = undefined;

  /** 物流方式 */
  logisticsTypeName = "";

  /** 数量 */
  qty = undefined;

  /** 参考单号 BO或者物流单 */
  referenceNo = "";

  /** 来源单号 TMS，OQ */
  sourceNo = "";

  /** 状态：10：待处理 20：已处理 30：已作废 */
  status = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 贸易术语 */
  tradeTerms = "";

  /** 报关类型：10：内部调拨 20：销售订单 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 体积 */
  volume = undefined;

  /** 重量 */
  weight = undefined;

  /** 整柜标识：0：否 1：是 */
  wholeCabinetFlag = undefined;
}

class CustomsDeclarationContractRequestDto {
  /** 报关批次号 */
  cbNo = "";

  /** 是否查验 0 否 1 是 */
  checkFlag = undefined;

  /** 合同号 */
  contractNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 申报日期 */
  declarationTime = "";

  /** 报关单 */
  declareNo = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 发票号 */
  invoiceNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class CustomsDeclarationContractResponseDto {
  /** 件数(箱) */
  boxQty = undefined;

  /** 报关批次号 */
  cbNo = "";

  /** 是否查验 0 否 1 是 */
  checkFlag = undefined;

  /** 合同号 */
  contractNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 申报日期 */
  declarationTime = "";

  /** 报关单号 */
  declareNo = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 发票号 */
  invoiceNo = "";

  /** 毛重(G) */
  packageWeight = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 净重(G) */
  weight = undefined;
}

class CustomsDeclarationDetailsRequestDto {
  /** 产品包装MPQ */
  boxMpq = undefined;

  /** 品牌 */
  brandName = "";

  /** 报关批次号 */
  cbNo = "";

  /** 合同号 */
  contractNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 汇率 */
  exchangeRate = undefined;

  /** 商品编号/HSCODE（国内） */
  hscodeCn = "";

  /** id */
  id = undefined;

  /** 型号 */
  model = "";

  /** 操作单号 */
  operationNo = "";

  /** po单号 */
  poNo = "";

  /** 单价 */
  price = undefined;

  /** 加成比例 */
  priceIncreaseRatio = undefined;

  /** 数量 */
  qty = undefined;

  /** po行号 */
  rowNo = undefined;

  /** sku已匹配数量 */
  skuMatchedQuantity = undefined;

  /** sku编号 */
  skuNo = "";

  /** 货源地 */
  sourceGoods = "";

  /** 供应商 */
  supplierCode = "";

  /** 单位 */
  unitName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 产品本体净重（kg） */
  weight = undefined;
}

class CustomsDeclarationItemRequestDto {
  /** 箱数 */
  boxQty = undefined;

  /** 品牌 */
  brandName = "";

  /** 报关批次号 */
  cbNo = "";

  /** 是否商检 0 否 1 是 */
  commodityInspectionFlag = undefined;

  /** 合同号 */
  contractNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 申报要素 */
  declareMemo = "";

  /** 品名 */
  declareName = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 汇率 */
  exchangeRate = undefined;

  /** 商品编号/HSCODE（国内） */
  hscodeCn = "";

  /** id */
  id = undefined;

  /** 匹配状态 0 未匹配  1 部分匹配  2 全部匹配 */
  matchedStatus = undefined;

  /** 型号 */
  model = "";

  /** 单价 */
  price = undefined;

  /** 数量 */
  qty = undefined;

  /** 序号 */
  serialNo = "";

  /** sku编号，逗号隔开 */
  skuStr = "";

  /** 供应商编号 */
  supplierCode = "";

  /** 是否可退税 0 否 1 是 */
  taxRefundEligible = undefined;

  /** 退税状态 0 未退税 1 已退税 2 无法退税 */
  taxRefundStatus = undefined;

  /** 总毛重(G) */
  totalPackageWeight = undefined;

  /** 总净重(G) */
  totalWeight = undefined;

  /** 单位 */
  unitName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class CustomsDeclarationItemResponseDto {
  /** 箱数 */
  boxQty = undefined;

  /** 品牌 */
  brandName = "";

  /** 报关批次号 */
  cbNo = "";

  /** 是否商检 0 否 1 是 */
  commodityInspectionFlag = undefined;

  /** 合同号 */
  contractNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 报关明细号 */
  declareDetailNo = "";

  /** 申报要素 */
  declareMemo = "";

  /** 品名 */
  declareName = "";

  /** 申报单价 */
  declarePrice = undefined;

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 汇率 */
  exchangeRate = undefined;

  /** 商品编号/HSCODE（国内） */
  hscodeCn = "";

  /** id */
  id = undefined;

  /** 匹配状态 0 未匹配  1 部分匹配  2 全部匹配 */
  matchedStatus = undefined;

  /** 型号 */
  model = "";

  /** 数量 */
  qty = undefined;

  /** 序号 */
  serialNo = "";

  /** sku编号，逗号隔开 */
  skuStr = "";

  /** 境内货源地 */
  sourceGoods = "";

  /** 供应商编号 */
  supplierCode = "";

  /** 是否可退税 0 否 1 是 */
  taxRefundEligible = undefined;

  /** 退税状态 0 未退税 1 已退税 2 无法退税 */
  taxRefundStatus = undefined;

  /** 申报总价 */
  totalDeclarePrice = undefined;

  /** 总毛重(G) */
  totalPackageWeight = undefined;

  /** 总净重(G) */
  totalWeight = undefined;

  /** 单位 */
  unitName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class CustomsDeclarationMasterRequestDto {
  /** 订舱类型： 整柜 散货 */
  cabinType = "";

  /** 报关批次号 */
  cbNo = "";

  /** 是否查验 */
  checkFlag = undefined;

  /** 集装箱号 */
  containerNo = "";

  /** 合同号 */
  contractNo = "";

  /** 贸易国 */
  countryName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间-结束 */
  createTimeEnd = "";

  /** 创建时间-开始 */
  createTimeStart = "";

  /** 币制 */
  currency = "";

  /** 报关员 */
  customsBroker = "";

  /** 报关单号 */
  declarationNo = "";

  /** 申报日期-结束 */
  declarationTimeEnd = "";

  /** 申报日期-开始 */
  declarationTimeStart = "";

  /** 报关代理 */
  declareAgent = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 最终目的国（地区) */
  destinationCountry = "";

  /** 境外收货人 */
  foreignReceiver = "";

  /** id */
  id = undefined;

  /** 是否上传提单附件 0 否 1是 */
  ladingFileFlag = undefined;

  /** 渠道服务编号 */
  logisticsChannelCode = "";

  /** 渠道服务名称 */
  logisticsChannelName = "";

  /** 渠道商编号 */
  logisticsProviderCode = "";

  /** 渠道商名称 */
  logisticsProviderName = "";

  /** 物流方式,数据字典： */
  logisticsType = undefined;

  /** 包装种类 */
  packagingType = "";

  /** 参考单号 BO或者物流单 */
  referenceNo = "";

  /** 审批备注 */
  remark = "";

  /** 境内货源地 */
  sourceGoods = "";

  /** 来源单号 TMS，OQ */
  sourceNo = "";

  /** 状态：10：待处理 20 : 待核对 30：已核对 40：已放行 50：待审核 60：已完成 70：已驳回 80：已作废 90：异常关闭 */
  status = undefined;

  /** 状态数组,多个,号拼接 */
  statusIn = "";

  /** 实际件数（箱） */
  totalBoxQty = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 贸易术语 */
  tradeTerms = "";

  /** 报关类型：10：内部调拨 20：销售订单 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间-结束 */
  updateTimeEnd = "";

  /** 更新时间-开始 */
  updateTimeStart = "";

  /** 过磅体积（cm³） */
  weighingVolume = undefined;

  /** 过磅重量（G） */
  weighingWeight = undefined;
}

class CustomsDeclarationMasterResponseDto {
  /** 代报关申请数组 */
  applyDetailsResponsesDtos = [];

  /** 订舱类型： 整柜 散货 */
  cabinType = "";

  /** 报关批次号 */
  cbNo = "";

  /** 是否查验 0 否 1是 */
  checkFlag = undefined;

  /** 是否商检 */
  commodityInspectionFlag = undefined;

  /** 集装箱号 */
  containerNo = "";

  /** 合同号数组 */
  contractNos = [];

  /** 报关合同数组 */
  contractResponseDtos = [];

  /** 贸易国 */
  countryName = "";

  /** 原产国(明细项) */
  countryOfOrigin = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币制(明细项) */
  currency = "";

  /** 报关员 */
  customsBroker = "";

  /** 报关单号数组 */
  customsDeclarationNos = [];

  /** 报关单附件 */
  declarationFilesRequestDtos = [];

  /** 报关代理code */
  declareAgent = "";

  /** 报关代理名称 */
  declareAgentName = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 最终目的国（地区)(明细项) */
  destinationCountry = "";

  /** 征免 */
  exempt = "";

  /** 征免性质 */
  exemptionNature = "";

  /** 境外收货人 */
  foreignReceiver = "";

  /** id */
  id = undefined;

  /** 是否合并报关 */
  isMerge = "";

  /** 报关明细项数组 */
  itemResponsesDtos = [];

  /** 是否上传提单附件 0 否 1是 */
  ladingFileFlag = undefined;

  /** 提单附件 */
  ladingFiles = [];

  /** 渠道服务编号 */
  logisticsChannelCode = "";

  /** 渠道服务名称 */
  logisticsChannelName = "";

  /** 渠道商编号 */
  logisticsProviderCode = "";

  /** 渠道商名称 */
  logisticsProviderName = "";

  /** 物流方式,数据字典： */
  logisticsType = undefined;

  /** 物流方式 */
  logisticsTypeName = "";

  /** 操作单号数组 */
  operationNos = [];

  /** 包装种类 */
  packagingType = "";

  /** 参考单号数组 */
  referenceNos = [];

  /** 审批备注 */
  remark = "";

  /** 状态：10：待处理 20 : 待核对 30：已核对 40：已放行 50：待审核 60：已完成 70：已驳回 80：已作废 90：异常关闭 */
  status = undefined;

  /** 监管方式 */
  supervisionWay = "";

  /** 实际件数（箱） */
  totalBoxQty = undefined;

  /** 数量（PCS） */
  totalQty = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称(也是境内发货人) */
  tradeCompanyName = "";

  /** 贸易术语 */
  tradeTerms = "";

  /** 报关类型：10：内部调拨 20：销售订单 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 过磅体积（cm³） */
  weighingVolume = undefined;

  /** 过磅重量（G） */
  weighingWeight = undefined;
}

class DeclarationDownloadResponseDto {
  /** 附件 */
  files = [];
}

class DeclareContractRequestParamsDto {
  /** 箱数 */
  boxQty = undefined;

  /** 重量 */
  boxWeight = undefined;

  /** 品牌 */
  brandName = "";

  /** bu名称 */
  buName = "";

  /** 是否商检 */
  commodityInspectionFlag = undefined;

  /** 合同号 */
  contractNo = "";

  /** 最终目的国（地区) */
  country = "";

  /** 原产国 */
  countryOfOrigin = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币制 */
  currencySystem = "";

  /** 申报要素 */
  declareMemo = "";

  /** 品名 */
  declareName = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 汇率 */
  exchangeRate = undefined;

  /** 征免 */
  exempt = "";

  /** 商品编号 */
  hscodeCn = "";

  /** id */
  id = undefined;

  /** 型号 */
  model = "";

  /** 单价 */
  price = undefined;

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 境内货源地 */
  sourceGoods = "";

  /** 子合同号 */
  subContractNo = "";

  /** 报关合同号 */
  suitableContractNo = "";

  /** 供应商id */
  supplierIdName = "";

  /** tms单号 */
  tmsno = "";

  /** 单位 */
  unitName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class DeclareContractResponseDto {
  /** 箱数 */
  boxQty = undefined;

  /** 重量 */
  boxWeight = undefined;

  /** 品牌 */
  brandName = "";

  /** bu名称 */
  buName = "";

  /** 是否商检 */
  commodityInspectionFlag = undefined;

  /** 合同号 */
  contractNo = "";

  /** 最终目的国（地区) */
  country = "";

  /** 原产国 */
  countryOfOrigin = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币制 */
  currencySystem = "";

  /** 申报要素 */
  declareMemo = "";

  /** 品名 */
  declareName = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 汇率 */
  exchangeRate = undefined;

  /** 征免 */
  exempt = "";

  /** 商品编号 */
  hscodeCn = "";

  /** id */
  id = undefined;

  /** idList */
  idList = [];

  /** 型号 */
  model = "";

  /** 单价 */
  price = undefined;

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 境内货源地 */
  sourceGoods = "";

  /** 子合同号 */
  subContractNo = "";

  /** 报关合同号 */
  suitableContractNo = "";

  /** 供应商id */
  supplierIdName = "";

  /** tms单号 */
  tmsno = "";

  /** 单位 */
  unitName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class ExportDeclarationAbnormalCloseRequestDto {
  /** tms单号 */
  tmsno = "";
}

class ExportDeclarationContractAndDeclarationRequestDto {
  /** 合同号 */
  contractNo = "";

  /** 报关单号 */
  suitableContractNo = "";
}

class ExportDeclarationDSHRequestDto {
  /** 审核意见 */
  approvalComments = "";

  /** 审核状态 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** tms单号 */
  tmsnoList = [];
}

class ExportDeclarationDownloadResponseDto {
  /** 出口报关附件 */
  exportDeclarationFiles = [];

  /** 提单附件 */
  ladingFiles = [];
}

class ExportDeclarationExportFileRequestDto {
  /** 是否查验 */
  checkFlag = undefined;

  /** 申报日期 */
  declarationTime = "";

  /** 合同号-报关合同号 */
  exportDeclarationContractAndDeclarationRequestDtos = [];

  /** 出口报关附件 */
  exportDeclarationFile = "";

  /** tms单号 */
  tmsno = "";
}

class ExportDeclarationRequestParamsDto {
  /** 审核意见 */
  approvalComments = "";

  /** 审核状态 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** 是否查验 */
  checkFlag = undefined;

  /** 是否商检 */
  commodityInspectionFlag = undefined;

  /** 集装箱号 */
  containerNo = "";

  /** 合同号 */
  contractNo = "";

  /** 贸易国 */
  countryName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 创建时间-结束 */
  createTimeEnd = "";

  /** 创建时间-开始 */
  createTimeStart = "";

  /** 报关员 */
  customsBroker = "";

  /** 申报日期 */
  declarationTime = "";

  /** 申报日期结束 */
  declarationTimeEnd = "";

  /** 申报日期开始 */
  declarationTimeStart = "";

  /** 报关代理 */
  declareAgent = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 截单日期 */
  endBillTime = "";

  /** 是否预录 */
  expectedEntryFlag = undefined;

  /** 出口报关附件 */
  exportDeclarationFile = "";

  /** 出口报关附件上传时间 */
  exportDeclarationTime = "";

  /** 出口报关附件上传时间-结束 */
  exportDeclarationTimeEnd = "";

  /** 出口报关附件上传时间-开始 */
  exportDeclarationTimeStart = "";

  /** 出口口岸 */
  exportPort = "";

  /** id */
  id = undefined;

  /** 提单附件 */
  ladingFile = "";

  /** 是否上传提单附件 */
  ladingFileFlag = "";

  /** 提单附件上传时间 */
  ladingTime = "";

  /** 提单附件上传时间-结束 */
  ladingTimeEnd = "";

  /** 提单附件上传时间-开始 */
  ladingTimeStart = "";

  /** '物流方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车' */
  logisticsType = undefined;

  /** 备注 */
  remark = "";

  /** 状态：10 待处理，20 已处理，30 已核对，40 已放行，50 待审核，60 驳回，70 已完成，80 已作废 */
  status = undefined;

  /** 订单状态多选，英文逗号分隔 */
  statusIn = "";

  /** 报关合同号 */
  suitableContractNo = "";

  /** tms单号 */
  tmsno = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 更新时间-结束 */
  updateTimeEnd = "";

  /** 更新时间-开始 */
  updateTimeStart = "";

  /** 物流单号 */
  waybillNo = "";
}

class ExportDeclarationResponseDto {
  /** 审核意见 */
  approvalComments = "";

  /** 审核状态 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** 是否查验 */
  checkFlag = undefined;

  /** 是否商检 */
  commodityInspectionFlag = undefined;

  /** 集装箱号 */
  containerNo = "";

  /** 合同号 */
  contractNos = [];

  /** 贸易国 */
  countryName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 报关员 */
  customsBroker = "";

  /** 申报日期 */
  declarationTime = "";

  /** 报关代理 */
  declareAgent = "";

  /** 合同号明细 */
  declareContractResponseDtos = [];

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 截单日期 */
  endBillTime = "";

  /** 是否预录 */
  expectedEntryFlag = undefined;

  /** 出口报关附件 */
  exportDeclarationFile = "";

  /** 出口报关附件上传时间 */
  exportDeclarationTime = "";

  /** 出口口岸 */
  exportPort = "";

  /** id */
  id = undefined;

  /** 提单附件 */
  ladingFile = "";

  /** 是否上传提单附件 */
  ladingFileFlag = undefined;

  /** 提单附件上传时间 */
  ladingTime = "";

  /** '物流方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车' */
  logisticsType = undefined;

  /** 备注 */
  remark = "";

  /** 状态：10：待处理 20：已处理 30：已核对 40：已放行 */
  status = undefined;

  /** 报关合同号 */
  suitableContractNos = [];

  /** tms单号 */
  tmsno = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体 */
  tradeCompanyName = "";

  /** 合同号明细 */
  transportMasterResponseDto = new TransportMasterResponseDto();

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 物流单号 */
  waybillNo = "";
}

class ExportDeclarationYFXRequestDto {
  /** 提单附件 */
  ladingFile = "";

  /** tms单号 */
  tmsno = "";
}

class ExportDeclarationYHDRequestDto {
  /** 是否查验 */
  checkFlag = undefined;

  /** 申报日期 */
  declarationTime = "";

  /** 合同号-报关合同号 */
  exportDeclarationContractAndDeclarationRequestDtos = [];

  /** 出口报关附件 */
  exportDeclarationFile = "";

  /** 出口口岸 */
  exportPort = "";

  /** 提单附件 */
  ladingFile = "";

  /** 提单附件上传时间 */
  ladingTime = "";

  /** tms单号 */
  tmsno = "";
}

class FinanceAndTaxationMasterResponseDto {
  /** TO号 */
  aono = "";

  /** 报关明细号 */
  customsDeclarationDetailNo = "";

  /** 品名 */
  declareNameCn = "";

  /** 进项税额 */
  differencePrice = undefined;

  /** 出口报关单号 */
  exportDeclarationNo = "";

  /** 采购含税金额 */
  hsAmount = undefined;

  /** 进项发票号 */
  invoiceNumber = "";

  /** nsPo单 */
  nsPono = "";

  /** 数量 */
  occupyQty = undefined;

  /** PO号 */
  pono = "";

  /** SKU */
  sku = "";

  /** 出口报关合同号 */
  suitableContractNo = "";

  /** 税率 */
  taxRate = undefined;

  /** TMS单号 */
  tmsno = "";

  /** 采购不含税金额 */
  unHsAmount = undefined;

  /** 单位 */
  unitName = "";

  /** 采购含税单价 */
  unitPrice = undefined;

  /** 物流单号 */
  waybillNo = "";
}

class FinanceAndTaxationResponseDto {
  /** TO号 */
  aono = "";

  /** 加价单价 */
  declarePrice = undefined;

  /** nsPo单 */
  nsPono = "";

  /** SKU */
  poSku = "";

  /** PO号 */
  pono = "";

  /** 行号 */
  rowNo = "";

  /** SKU */
  sku = "";

  /** 税率 */
  taxRate = undefined;

  /** 占位数量 */
  tmsQty = undefined;

  /** 交易主体 */
  tradeCompanyName = "";

  /** 采购不含税金额 */
  unHsPrice = undefined;

  /** 采购含税单价 */
  unitPrice = undefined;

  /** 调拨单数量 */
  wmsQty = undefined;
}

class FreightResponseDto {
  /** 基本运费 */
  basicFreight = undefined;

  /** 渠道id */
  channelId = undefined;

  /** 渠道名称 */
  channelName = "";

  /** 错误信息 */
  errorMsg = "";

  /** 物流商名称 */
  providerName = "";

  /** 结算重量 */
  settlementWeight = undefined;

  /** 附加费 */
  surcharge = undefined;

  /** 总运费 */
  totalFreight = undefined;
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class LogisticsChannelCreateRequestDto {
  /** 平均时效 (天) */
  averageDay = undefined;

  /** 渠道编号 */
  channelCode = "";

  /** 渠道名称 */
  channelName = "";

  /** 渠道英文名称 */
  channelNameEn = "";

  /** 渠道类型 10:快递类 20:邮政类 30:专线类 40:卡派 50:快递 60:整柜直送 */
  channelType = undefined;

  /** 联系方式 */
  contact = "";

  /** 计泡基数 */
  countBubbleBase = undefined;

  /** 计重类型 10：毛重体积重最大值/Max(材积,实重), 20：方/立方米, 30：体积重 */
  countWeightType = undefined;

  /** 默认进位重 */
  defaultCarryBit = undefined;

  /** 折扣  默认1.0 */
  discount = undefined;

  /** 面单要求 */
  labelStandard = "";

  /** 物流渠道货物规格限制规则 */
  limit = new LogisticsChannelLimitRequestDto();

  /** 渠道特征 10快船，20普船 */
  logisticsFeatures = undefined;

  /** 物流分组列表 */
  logisticsGroupList = [];

  /** 物流方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车 */
  logisticsType = undefined;

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 业务属性分类 10：toC, 20：toB */
  serviceProperty = undefined;

  /** 运输方式：10 sea-普通，20 air-快递-红单，30 air-专线-红单 */
  shippingType = undefined;

  /** 状态 1:启用 0:停用 */
  status = undefined;

  /** 是否包税 0否 1是 */
  taxInclusiveFlag = undefined;

  /** 物流渠道覆盖区域列表 */
  zoneList = [];
}

class LogisticsChannelLimitRequestDto {
  /** 禁发sku */
  banSku = "";

  /** 物流渠道编号 */
  channelCode = "";

  /** 物流渠道ID */
  channelId = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 平台限制 */
  excludedPlatforms = "";

  /** 长+2宽+2高度最大值(cm) */
  girthMax = undefined;

  /** 高度范围最大值(cm) */
  heightMax = undefined;

  /** 高度范围最小值(cm) */
  heightMin = undefined;

  /** id */
  id = undefined;

  /** 长度范围最大值(cm) */
  lengthMax = undefined;

  /** 长度范围最小值(cm) */
  lengthMin = undefined;

  /** 允许超长+2宽+2高度合计标识 0：否 1：是 */
  overGirthFlag = undefined;

  /** 允许超高标识 0：否 1：是 */
  overHeightFlag = undefined;

  /** 允许超长标识 0：否 1：是 */
  overLengthFlag = undefined;

  /** 允许超长宽高合计标识 0：否 1：是 */
  overSideLengthSumFlag = undefined;

  /** 允许超大标识 0：否 1：是 */
  overVolumeFlag = undefined;

  /** 允许超重标识 0：否 1：是 */
  overWeightFlag = undefined;

  /** 允许超宽标识 0：否 1：是 */
  overWidthFlag = undefined;

  /** 物流商编号 */
  providerCode = "";

  /** 最大件数 */
  qtyMax = undefined;

  /** 最小件数 */
  qtyMin = undefined;

  /** 长宽高合计最大值(cm) */
  sideLengthSumMax = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 体积范围最大值(cm³) */
  volumeMax = undefined;

  /** 重量范围最大值(g) */
  weightMax = undefined;

  /** 宽度范围最大值(cm) */
  widthMax = undefined;

  /** 宽度范围最小值(cm) */
  widthMin = undefined;
}

class LogisticsChannelLimitResponseDto {
  /** 禁发sku */
  banSku = "";

  /** 物流渠道编号 */
  channelCode = "";

  /** 物流渠道ID */
  channelId = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 平台限制 */
  excludedPlatforms = "";

  /** 长+2宽+2高度最大值(cm) */
  girthMax = undefined;

  /** 高度范围最大值(cm) */
  heightMax = undefined;

  /** 高度范围最小值(cm) */
  heightMin = undefined;

  /** id */
  id = undefined;

  /** 长度范围最大值(cm) */
  lengthMax = undefined;

  /** 长度范围最小值(cm) */
  lengthMin = undefined;

  /** 允许超长+2宽+2高度合计标识 0：否 1：是 */
  overGirthFlag = undefined;

  /** 允许超高标识 0：否 1：是 */
  overHeightFlag = undefined;

  /** 允许超长标识 0：否 1：是 */
  overLengthFlag = undefined;

  /** 允许超长宽高合计标识 0：否 1：是 */
  overSideLengthSumFlag = undefined;

  /** 允许超大标识 0：否 1：是 */
  overVolumeFlag = undefined;

  /** 允许超重标识 0：否 1：是 */
  overWeightFlag = undefined;

  /** 允许超宽标识 0：否 1：是 */
  overWidthFlag = undefined;

  /** 物流商编号 */
  providerCode = "";

  /** 最大件数 */
  qtyMax = undefined;

  /** 最小件数 */
  qtyMin = undefined;

  /** 长宽高合计最大值(cm) */
  sideLengthSumMax = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 体积范围最大值(cm³) */
  volumeMax = undefined;

  /** 重量范围最大值(g) */
  weightMax = undefined;

  /** 宽度范围最大值(cm) */
  widthMax = undefined;

  /** 宽度范围最小值(cm) */
  widthMin = undefined;
}

class LogisticsChannelLimitUpdateDto {
  /** 禁发sku */
  banSku = "";

  /** 物流渠道编号 */
  channelCode = "";

  /** 平台限制 */
  excludedPlatforms = "";

  /** 长+2宽+2高度最大值(cm) */
  girthMax = undefined;

  /** 高度范围最大值(cm) */
  heightMax = undefined;

  /** 高度范围最小值(cm) */
  heightMin = undefined;

  /** 长度范围最大值(cm) */
  lengthMax = undefined;

  /** 长度范围最小值(cm) */
  lengthMin = undefined;

  /** 允许超长+2宽+2高度合计标识 0：否 1：是 */
  overGirthFlag = undefined;

  /** 允许超高标识 0：否 1：是 */
  overHeightFlag = undefined;

  /** 允许超长标识 0：否 1：是 */
  overLengthFlag = undefined;

  /** 允许超长宽高合计标识 0：否 1：是 */
  overSideLengthSumFlag = undefined;

  /** 允许超大标识 0：否 1：是 */
  overVolumeFlag = undefined;

  /** 允许超重标识 0：否 1：是 */
  overWeightFlag = undefined;

  /** 允许超宽标识 0：否 1：是 */
  overWidthFlag = undefined;

  /** 物流商编号 */
  providerCode = "";

  /** 最大件数 */
  qtyMax = undefined;

  /** 最小件数 */
  qtyMin = undefined;

  /** 长宽高合计最大值(cm) */
  sideLengthSumMax = undefined;

  /** 体积范围最大值(cm³) */
  volumeMax = undefined;

  /** 重量范围最大值(g) */
  weightMax = undefined;

  /** 宽度范围最大值(cm) */
  widthMax = undefined;

  /** 宽度范围最小值(cm) */
  widthMin = undefined;
}

class LogisticsChannelListResponseDto {
  /** 物流渠道编号 */
  channelCode = "";

  /** 物流渠道名称 */
  channelName = "";

  /** id */
  id = undefined;

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";
}

class LogisticsChannelLogisticsGroupRequestDto {
  /** 物流分组ID */
  groupId = undefined;

  /** 物流分组名称（CN） */
  groupNameCn = "";

  /** 物流分组名称（EN） */
  groupNameEn = "";

  /** 物流分组编号 */
  groupNo = "";
}

class LogisticsChannelLogisticsGroupResponseDto {
  /** 物流渠道编号 */
  channelCode = "";

  /** 物流渠道ID */
  channelId = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 物流分组ID */
  groupId = undefined;

  /** 物流分组名称（CN） */
  groupNameCn = "";

  /** 物流分组名称（EN） */
  groupNameEn = "";

  /** 物流分组编号 */
  groupNo = "";

  /** id */
  id = undefined;

  /** 物流分组 */
  logisticsGroup = "";

  /** 物流商编号 */
  providerCode = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsChannelLogisticsGroupUpdateDto {
  /** 物流渠道编号 */
  channelCode = "";

  /** 物流渠道限制列表 */
  logisticsGroupList = [];

  /** 物流商编号 */
  providerCode = "";
}

class LogisticsChannelMappingModel {
  /** 费用类型 */
  costType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 组织名称 */
  mappingOrganizeName = "";

  /** 供应商编号 */
  mappingSupplierCode = "";

  /** 供应商名称 */
  mappingSupplierName = "";

  /** 交易主体编号 */
  mappingTradeCompanyCode = "";

  /** 交易主体名称 */
  mappingTradeCompanyName = "";

  /** 组织名称 */
  organizeName = "";

  /** 站点 */
  site = "";

  /** 供应商编号 */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsChannelPlatformDto {
  /** 渠道码 */
  channelCode = "";

  /** 平台映射明细 */
  logisticsChannelPlatformList = [];

  /** 渠道商码 */
  providerCode = "";
}

class LogisticsChannelPlatformRequestDto {
  /** 物流渠道编号 */
  channelCode = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 10:货物到达后不生成最终单号，20:货物到达后生成最终单号 */
  isGenerateFtno = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 平台邮寄方式名字 */
  platformPost = "";

  /** 平台邮寄方式编号 */
  platformPostCode = "";

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;

  /** 跟踪地址 */
  traceAddresse = "";

  /** 10:取最终单号，20:取物流商单号 */
  trackingNoType = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 10:上传运单号，20:不填单号上传，30:NoShipping */
  waybillNoUploadWay = undefined;
}

class LogisticsChannelPlatformResponseDto {
  /** 物流渠道编号 */
  channelCode = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 10:货物到达后不生成最终单号，20:货物到达后生成最终单号 */
  isGenerateFtno = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 平台邮寄方式 */
  platformPost = "";

  /** 平台邮寄方式编码 */
  platformPostCode = "";

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;

  /** 跟踪地址 */
  traceAddresse = "";

  /** 10:取最终单号，20:取物流商单号 */
  trackingNoType = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 10:上传运单号，20:不填单号上传，30:NoShipping */
  waybillNoUploadWay = undefined;
}

class LogisticsChannelPriceCreateRequestDto {
  /** 续重费用 */
  additionalWeightPrice = undefined;

  /** 续重单位数量 */
  additionalWeightUnit = undefined;

  /** 开始重量 */
  beginWeight = undefined;

  /** 物流渠道编号 */
  channelCode = "";

  /** 物流渠道名称 */
  channelName = "";

  /** 结束重量 */
  endWeight = undefined;

  /** 附加费续重费用 */
  excessAdditionalWeightPrice = undefined;

  /** 附加费续重单位 */
  excessAdditionalWeightUnit = undefined;

  /** 附加费首重 */
  excessFirstWeight = undefined;

  /** 附加费首重费用 */
  excessFirstWeightPrice = undefined;

  /** 首重 */
  firstWeight = undefined;

  /** 首重费用(RMB) */
  firstWeightPrice = undefined;

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 挂号费(RMB) */
  registrationPrice = undefined;

  /** 目标国家简码 */
  targetCountryCode = "";

  /** 目标国家名称 */
  targetCountryName = "";
}

class LogisticsChannelPriceResponseDto {
  /** 续重费用 */
  additionalWeightPrice = undefined;

  /** 续重单位数量 */
  additionalWeightUnit = undefined;

  /** begin重量 > */
  beginWeight = undefined;

  /** 物流渠道编号 */
  channelCode = "";

  /** 物流渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** end重量 <= */
  endWeight = undefined;

  /** 附加费续重费用 */
  excessAdditionalWeightPrice = undefined;

  /** 附加费续重单位 */
  excessAdditionalWeightUnit = undefined;

  /** 附加费首重 */
  excessFirstWeight = undefined;

  /** 附加费首重费用 */
  excessFirstWeightPrice = undefined;

  /** 首重 */
  firstWeight = undefined;

  /** 首重费用(RMB)  */
  firstWeightPrice = undefined;

  /** id */
  id = undefined;

  /** 邮编匹配正则 */
  matchPostcode = "";

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 挂号费(RMB) */
  registrationPrice = undefined;

  /** 目标国家简码 */
  targetCountryCode = "";

  /** 目标国家名称 */
  targetCountryName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsChannelPriceUpdateRequestDto {
  /** 续重费用 */
  additionalWeightPrice = undefined;

  /** 续重单位数量 */
  additionalWeightUnit = undefined;

  /** 开始重量 */
  beginWeight = undefined;

  /** 物流渠道编号 */
  channelCode = "";

  /** 物流渠道名称 */
  channelName = "";

  /** 结束重量 */
  endWeight = undefined;

  /** 附加费续重费用 */
  excessAdditionalWeightPrice = undefined;

  /** 附加费续重单位 */
  excessAdditionalWeightUnit = undefined;

  /** 附加费首重 */
  excessFirstWeight = undefined;

  /** 附加费首重费用 */
  excessFirstWeightPrice = undefined;

  /** 首重 */
  firstWeight = undefined;

  /** 首重费用(RMB) */
  firstWeightPrice = undefined;

  /** ID */
  id = undefined;

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 挂号费(RMB) */
  registrationPrice = undefined;

  /** 目标国家简码 */
  targetCountryCode = "";

  /** 目标国家名称 */
  targetCountryName = "";
}

class LogisticsChannelRequestDto {
  /** 渠道编号 */
  channelCode = "";

  /** 渠道名称 */
  channelName = "";

  /** 渠道英文名称 */
  channelNameEn = "";

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";
}

class LogisticsChannelResponseDto {
  /** 渠道编号 */
  channelCode = "";

  /** 渠道名称 */
  channelName = "";

  /** 渠道英文名称 */
  channelNameEn = "";

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;
}

class LogisticsChannelTobCreateRequestDto {
  /** 渠道服务编号 */
  channelCode = "";

  /** 渠道服务名称 */
  channelName = "";

  /** 渠道服务英文名称 */
  channelNameEn = "";

  /** 渠道商编号 */
  providerCode = "";

  /** 渠道商名称 */
  providerName = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;
}

class LogisticsChannelTobRequestParamsDto {
  /** 渠道服务编号 */
  channelCode = "";

  /** 渠道服务名称 */
  channelName = "";

  /** 渠道服务英文名称 */
  channelNameEn = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 渠道商编号 */
  providerCode = "";

  /** 渠道商名称 */
  providerName = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsChannelTobResponseDto {
  /** 渠道服务编号 */
  channelCode = "";

  /** 渠道服务名称 */
  channelName = "";

  /** 渠道服务英文名称 */
  channelNameEn = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 渠道商编号 */
  providerCode = "";

  /** 渠道商名称 */
  providerName = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsChannelTobUpdateRequestDto {
  /** 渠道服务编号 */
  channelCode = "";

  /** 渠道服务名称 */
  channelName = "";

  /** 渠道服务英文名称 */
  channelNameEn = "";

  /** ID */
  id = undefined;

  /** 渠道商编号 */
  providerCode = "";

  /** 渠道商名称 */
  providerName = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;
}

class LogisticsChannelUpdateRequestDto {
  /** 平均时效 (天) */
  averageDay = undefined;

  /** 渠道类型 10:快递类 20:邮政类 30:专线类 */
  channelType = undefined;

  /** 联系方式 */
  contact = "";

  /** 计泡基数 */
  countBubbleBase = undefined;

  /** 计重类型 10：毛重体积重最大值/Max(材积,实重), 20：方/立方米, 30：体积重 */
  countWeightType = undefined;

  /** 默认进位重 */
  defaultCarryBit = undefined;

  /** 折扣  默认1.0 */
  discount = undefined;

  /** ID */
  id = undefined;

  /** 面单要求 */
  labelStandard = "";

  /** 渠道特征 10快船，20普船 */
  logisticsFeatures = undefined;

  /** 物流方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车 */
  logisticsType = undefined;

  /** 业务属性分类 10：toC, 20：toB */
  serviceProperty = undefined;

  /** 运输方式：10 sea-普通，20 air-快递-红单，30 air-专线-红单 */
  shippingType = undefined;

  /** 状态 1:启用 0:停用 */
  status = undefined;

  /** 是否包税 0否 1是 */
  taxInclusiveFlag = undefined;
}

class LogisticsChannelWarehouseRequestDto {
  /** id 添加不用传，编辑时必传 */
  id = undefined;

  /** 渠道集合 */
  logisticsChannelRequestDto = [];

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class LogisticsChannelWarehouseResponseDto {
  /** 物流渠道编号 */
  channelCode = "";

  /** 物流渠道列表 */
  channelListResponseDtoList = [];

  /** 物流渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class LogisticsChannelZoneCreateRequestDto {
  /** 邮编范围止 */
  postcodeEnd = "";

  /** 邮编范围起 */
  postcodeStart = "";

  /** 目的国家名称 */
  targetCountryCode = "";

  /** 目的国家简码 */
  targetCountryName = "";

  /** 分区模式 0:按国家 1:按国家+邮编 */
  zoneModel = undefined;
}

class LogisticsChannelZoneResponseDto {
  /** 物流渠道编号 */
  channelCode = "";

  /** 物流渠道ID */
  channelId = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 邮编范围止 */
  postcodeEnd = "";

  /** 邮编范围起 */
  postcodeStart = "";

  /** 物流商编号 */
  providerCode = "";

  /** 目的国家名称 */
  targetCountryCode = "";

  /** 目的国家简码 */
  targetCountryName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 分区模式 0:按国家 1:按国家+邮编 */
  zoneModel = undefined;
}

class LogisticsChannelZoneUpdateDto {
  /** 物流渠道编号 */
  channelCode = "";

  /** 物流渠道覆盖区域列表 */
  logisticsChannelZoneList = [];

  /** 物流商编号 */
  providerCode = "";
}

class LogisticsGroupResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** 物流分组名称（CN） */
  groupNameCn = "";

  /** 物流分组名称（EN） */
  groupNameEn = "";

  /** 物流分组编号 */
  groupNo = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsMatchDetailRequestDto {
  /** SKU数量 */
  qty = undefined;

  /** sku */
  sku = "";
}

class LogisticsMatchRequestDto {
  /** 地址 */
  address = "";

  /** 地址2 */
  address2 = "";

  /** 城市 */
  city = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** sku明细 */
  detailRequestDtos = [];

  /** 邮箱地址 */
  email = "";

  /** 优先匹配类型： time 时效   price 价格 */
  firstType = "";

  /** 移动电话 */
  mobilePhone = "";

  /** 出库计划单号 */
  opno = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 省份编号 */
  provinceCode = "";

  /** 收件人 */
  recipient = "";

  /** 收件人纳税号 */
  taxid = "";

  /** 固定电话 */
  telephone = "";

  /** 仓库编号 */
  warehouseCodes = [];
}

class LogisticsMatchResponseDto {
  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流预估运费 */
  logisticsPrice = undefined;

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 平台邮寄方式 */
  platformPost = "";

  /** 跟踪地址 */
  traceAddresse = "";

  /** 仓库编号 */
  warehouseCode = "";
}

class LogisticsMatchTestDto {
  /** 渠道服务编号 */
  channelCode = "";

  /** 国家简码 */
  countryCode = "";

  /** sku明细 */
  detailRequestDtos = [];

  /** 优先匹配类型： time 时效   price 价格 */
  firstType = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 邮编 */
  postcode = "";

  /** providerCode */
  providerCode = "";

  /** 仓库编号 */
  warehouseCodes = [];
}

class LogisticsPlatformResponseDto {
  /** 物流渠道编号 */
  channelCode = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 10:货物到达后不生成最终单号，20:货物到达后生成最终单号 */
  isGenerateFtno = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 平台邮寄方式 */
  platformPost = "";

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;

  /** 跟踪地址 */
  traceAddresse = "";

  /** 10:取最终单号，20:取物流商单号 */
  trackingNoType = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 10:上传运单号，20:不填单号上传，30:NoShipping */
  waybillNoUploadWay = undefined;
}

class LogisticsProviderCreateRequestDto {
  /** 联系方式 */
  contact = "";

  /** 预报邮箱 */
  forecastMails = "";

  /** 收款明细 */
  paymentRequestDtos = [];

  /** 物流商对应的限定平台 */
  platformName = "";

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 物流商英文名称 */
  providerNameEn = "";

  /** 业务属性分类 10：toC, 20：toB */
  serviceProperty = undefined;

  /** 结算周期(天) */
  settlementCycle = undefined;

  /** 结算方式 10月结，20现结 */
  settlementMethod = undefined;

  /** 状态 1:启用 0:停用 */
  status = undefined;
}

class LogisticsProviderPaymentRequestDto {
  /** id */
  id = undefined;

  /** 收款人名称 */
  payeeAccountName = "";

  /** 收款人开户行 */
  payeeBankName = "";

  /** 收款人银行账户 */
  payeeBankNumber = "";

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";
}

class LogisticsProviderPaymentResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 收款人名称 */
  payeeAccountName = "";

  /** 收款人开户行 */
  payeeBankName = "";

  /** 收款人银行账户 */
  payeeBankNumber = "";

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsProviderPaymentTobRequestDto {
  /** id */
  id = undefined;

  /** 收款人名称 */
  payeeAccountName = "";

  /** 收款人开户行 */
  payeeBankName = "";

  /** 收款人银行账户 */
  payeeBankNumber = "";

  /** 渠道商编号 */
  providerCode = "";

  /** 渠道商名称 */
  providerName = "";
}

class LogisticsProviderPaymentTobResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 收款人名称 */
  payeeAccountName = "";

  /** 收款人开户行 */
  payeeBankName = "";

  /** 收款人银行账户 */
  payeeBankNumber = "";

  /** 渠道商编号 */
  providerCode = "";

  /** 渠道商名称 */
  providerName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsProviderResponseDto {
  /** 联系方式 */
  contact = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 预报邮箱 */
  forecastMails = "";

  /** id */
  id = undefined;

  /** 面单要求 */
  labelStandard = "";

  /** 物流商对应的限定平台 */
  platformName = "";

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 物流商英文名称 */
  providerNameEn = "";

  /** 业务属性分类 10：toC, 20：toB */
  serviceProperty = undefined;

  /** 结算周期(天) */
  settlementCycle = undefined;

  /** 结算方式 10月结，20现结 */
  settlementMethod = undefined;

  /** 状态 1:启用 0:停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsProviderTobCreateRequestDto {
  /** 联系方式 */
  contact = "";

  /** 预报邮箱 */
  forecastMails = "";

  /** 收款明细 */
  paymentRequestDtos = [];

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 物流商英文名称 */
  providerNameEn = "";

  /** 账期周期(天) */
  settlementCycle = undefined;

  /** 账期方式 10月结，20现结 */
  settlementMethod = undefined;

  /** 状态 1:启用 0:停用 */
  status = undefined;
}

class LogisticsProviderTobRequestParamsDto {
  /** 联系方式 */
  contact = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 预报邮箱 */
  forecastMails = "";

  /** id */
  id = undefined;

  /** 渠道商编号 */
  providerCode = "";

  /** 渠道商名称 */
  providerName = "";

  /** 渠道商英文名称 */
  providerNameEn = "";

  /** 结算周期(天) */
  settlementCycle = undefined;

  /** 账期方式 10月结，20现结 */
  settlementMethod = undefined;

  /** 状态 1:启用 0:停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsProviderTobResponseDto {
  /** 联系方式 */
  contact = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 预报邮箱 */
  forecastMails = "";

  /** id */
  id = undefined;

  /** 渠道商编号 */
  providerCode = "";

  /** 渠道商名称 */
  providerName = "";

  /** 渠道商英文名称 */
  providerNameEn = "";

  /** 结算周期(天) */
  settlementCycle = undefined;

  /** 账期方式 10月结，20现结 */
  settlementMethod = undefined;

  /** 状态 1:启用 0:停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsProviderTobUpdateRequestDto {
  /** 联系方式 */
  contact = "";

  /** 预报邮箱 */
  forecastMails = "";

  /** ID */
  id = undefined;

  /** 收款明细 */
  paymentRequestDtos = [];

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 物流商英文名称 */
  providerNameEn = "";

  /** 账期周期(天) */
  settlementCycle = undefined;

  /** 账期方式 10月结，20现结 */
  settlementMethod = undefined;

  /** 状态 1:启用 0:停用 */
  status = undefined;
}

class LogisticsProviderUpdateRequestDto {
  /** 联系方式 */
  contact = "";

  /** 预报邮箱 */
  forecastMails = "";

  /** ID */
  id = undefined;

  /** 面单要求 */
  labelStandard = "";

  /** 收款明细 */
  paymentRequestDtos = [];

  /** 物流商对应的限定平台 */
  platformName = "";

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 物流商英文名称 */
  providerNameEn = "";

  /** 业务属性分类 10：toC, 20：toB */
  serviceProperty = undefined;

  /** 结算周期(天) */
  settlementCycle = undefined;

  /** 结算方式 10月结，20现结 */
  settlementMethod = undefined;

  /** 状态 1:启用 0:停用 */
  status = undefined;
}

class LogisticsQuotationCreateDto {
  /** 物流渠道编号 */
  channelCode = "";

  /** 物流渠道ID */
  channelId = undefined;

  /** 燃油附加费比例% */
  fuelSurchargeProportion = undefined;

  /** 处理费 */
  processingFee = undefined;

  /** 物流商编号 */
  providerCode = "";

  /** 物流报价-报价信息 */
  quotationInfo = new LogisticsQuotationInfoCreateDto();

  /** 报价方案名称 */
  quotationName = "";

  /** 物流报价-附加费信息 */
  quotationSurchargeInfoList = [];

  /** 运费折扣比例% */
  shippingDiscountProportion = undefined;
}

class LogisticsQuotationDetailTobRequestDto {
  /** centerId */
  centerId = "";

  /** 渠道服务编号 */
  channelCode = "";

  /** 目的国编码 */
  destinationCountryCode = "";

  /** 目的国名称 */
  destinationCountryName = "";

  /** 40GP（CNY每票） */
  fortyGpProportionCost = undefined;

  /** 20GP（CNY每票） */
  gpProportionCost = undefined;

  /** 40HQ（CNY每票） */
  hqProportionCost = undefined;

  /** id */
  id = undefined;

  /** 进口清关费 */
  importClearanceCost = undefined;

  /** 价格 */
  price = undefined;

  /** 渠道商编号 */
  providerCode = "";

  /** 报价方案编号 */
  quotationCode = "";

  /** 始发地编号（起运港编号） */
  startPortCode = "";

  /** 始发地名称（起运港名称） */
  startPortName = "";

  /** 取最大值 */
  takeTheMaximum = undefined;

  /** 取最小值 */
  takeTheMinimum = undefined;

  /** 仓库编号 */
  targetWarehouseCode = "";

  /** 目的仓库名称 */
  targetWarehouseName = "";
}

class LogisticsQuotationDetailTobRequestParamsDto {
  /** centerId */
  centerId = "";

  /** 渠道服务编号 */
  channelCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 目的国编码 */
  destinationCountryCode = "";

  /** 目的国名称 */
  destinationCountryName = "";

  /** 20GP（CNY每票） */
  gpProportionCost = undefined;

  /** 40HQ（CNY每票） */
  hqProportionCost = undefined;

  /** id */
  id = undefined;

  /** 进口清关费 */
  importClearanceCost = undefined;

  /** 价格 */
  price = undefined;

  /** 渠道商编号 */
  providerCode = "";

  /** 报价方案编号 */
  quotationCode = "";

  /** 始发地编号（起运港编号） */
  startPortCode = "";

  /** 始发地名称（起运港名称） */
  startPortName = "";

  /** 取最大值 */
  takeTheMaximum = undefined;

  /** 取最小值 */
  takeTheMinimum = undefined;

  /** 仓库编号 */
  targetWarehouseCode = "";

  /** 目的仓库名称 */
  targetWarehouseName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsQuotationDetailTobResponseDto {
  /** centerId */
  centerId = "";

  /** 渠道服务编号 */
  channelCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 目的国编码 */
  destinationCountryCode = "";

  /** 目的国名称 */
  destinationCountryName = "";

  /** 40GP（CNY每票） */
  fortyGpProportionCost = undefined;

  /** 20GP（CNY每票） */
  gpProportionCost = undefined;

  /** 40HQ（CNY每票） */
  hqProportionCost = undefined;

  /** id */
  id = undefined;

  /** 进口清关费 */
  importClearanceCost = undefined;

  /** 价格 */
  price = undefined;

  /** 渠道商编号 */
  providerCode = "";

  /** 报价方案编号 */
  quotationCode = "";

  /** 始发地编号（起运港编号） */
  startPortCode = "";

  /** 始发地名称（起运港名称） */
  startPortName = "";

  /** 取最大值 */
  takeTheMaximum = undefined;

  /** 取最小值 */
  takeTheMinimum = undefined;

  /** 仓库编号 */
  targetWarehouseCode = "";

  /** 目的仓库名称 */
  targetWarehouseName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsQuotationInfoCreateDto {
  /** 计价模式ID 0:按首重+续重 1：按重量段+单价 2：按重量段+总价 */
  priceModel = undefined;

  /** 物流报价-报价信息-分区列表 */
  quotationZoneList = [];

  /** 分区模式 0:按国家 1:按国家+邮编 */
  zoneModel = undefined;
}

class LogisticsQuotationInfoRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 物流报价方案ID */
  logisticsQuotationId = undefined;

  /** 物流报价方案名称 */
  logisticsQuotationName = "";

  /** 计价模式ID 0:按首重+续重 1：按重量段+单价 2：按重量段+总价 */
  priceModel = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 分区模式 0:按国家 1:按国家+邮编 */
  zoneModel = undefined;
}

class LogisticsQuotationInfoResponseDto {
  /** id */
  id = undefined;

  /** 物流报价方案ID */
  logisticsQuotationId = undefined;

  /** 物流报价方案名称 */
  logisticsQuotationName = "";

  /** 计价模式ID 0:按首重+续重 1：按重量段+单价 2：按重量段+总价 */
  priceModel = undefined;

  /** 物流报价-报价信息-分区列表 */
  quotationZoneList = [];

  /** 分区模式 0:按国家 1:按国家+邮编 */
  zoneModel = undefined;
}

class LogisticsQuotationInfoUpdateDto {
  /** id */
  id = undefined;

  /** 物流报价方案ID */
  logisticsQuotationId = undefined;

  /** 物流报价方案名称 */
  logisticsQuotationName = "";

  /** 计价模式ID 0:按首重+续重 1：按重量段+单价 2：按重量段+总价 */
  priceModel = undefined;

  /** 物流报价-报价信息-分区列表 */
  quotationZoneList = [];

  /** 分区模式 0:按国家 1:按国家+邮编 */
  zoneModel = undefined;
}

class LogisticsQuotationPriceTobRequestDto {
  /** centerId */
  centerId = "";

  /** 渠道服务编号 */
  channelCode = "";

  /** 装柜类型: 10 散货,20 20GP,30 40HQ, 40 40GP */
  loadCabinType = undefined;

  /** 渠道商编号 */
  providerCode = "";

  /** 起运港编号 */
  startPortCode = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 体积 */
  value = undefined;

  /** 重量 */
  weight = undefined;
}

class LogisticsQuotationRequestDto {
  /** 物流渠道编号 */
  channelCode = "";

  /** 物流渠道ID */
  channelId = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 燃油附加费比例% */
  fuelSurchargeProportion = undefined;

  /** id */
  id = undefined;

  /** 处理费 */
  processingFee = undefined;

  /** 物流商编号 */
  providerCode = "";

  /** 报价方案名称 */
  quotationName = "";

  /** 运费折扣比例% */
  shippingDiscountProportion = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsQuotationResponseDto {
  /** 物流渠道编号 */
  channelCode = "";

  /** 物流渠道ID */
  channelId = undefined;

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 燃油附加费比例% */
  fuelSurchargeProportion = undefined;

  /** id */
  id = undefined;

  /** 处理费 */
  processingFee = undefined;

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 物流报价-报价信息 */
  quotationInfo = new LogisticsQuotationInfoResponseDto();

  /** 报价方案名称 */
  quotationName = "";

  /** 物流报价-附加费信息 */
  quotationSurchargeInfoList = [];

  /** 运费折扣比例% */
  shippingDiscountProportion = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsQuotationSurchargeFormulaCreateDto {
  /** 条件规则类型 0：长 1：宽 2：高 3：三边之和 4：长+2*宽*2高 5：重 6：体积 7：物流分组 8：邮编分区 */
  conditionObjectType = undefined;

  /** 条件值 */
  conditionValue = "";

  /** 运算符 */
  operatorName = "";

  /** 运算符类型 0:= 1:> 2:>= 3:< 4:<= */
  operatorType = undefined;
}

class LogisticsQuotationSurchargeFormulaRequestDto {
  /** 条件规则类型 0：长 1：宽 2：高 3：三边之和 4：长+2*宽*2高 5：重 6：体积 7：物流分组 8：邮编分区 */
  conditionObjectType = undefined;

  /** 条件值 */
  conditionValue = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 物流报价方案ID */
  logisticsQuotationId = undefined;

  /** 运算符 */
  operatorName = "";

  /** 运算符类型 0:= 1:> 2:>= 3:< 4:<= */
  operatorType = undefined;

  /** 条件规则ID */
  surchargeRuleId = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsQuotationSurchargeFormulaResponseDto {
  /** 条件规则类型 0：长 1：宽 2：高 3：三边之和 4：长+2*宽*2高 5：重 6：体积 7：物流分组 8：邮编分区 */
  conditionObjectType = undefined;

  /** 条件值 */
  conditionValue = "";

  /** id */
  id = undefined;

  /** 物流报价方案ID */
  logisticsQuotationId = undefined;

  /** 运算符 */
  operatorName = "";

  /** 运算符类型 0:= 1:> 2:>= 3:< 4:<= */
  operatorType = undefined;

  /** 条件规则ID */
  surchargeRuleId = undefined;
}

class LogisticsQuotationSurchargeFormulaUpdateDto {
  /** 条件规则类型 0：长 1：宽 2：高 3：三边之和 4：长+2*宽*2高 5：重 6：体积 7：物流分组 8：邮编分区 */
  conditionObjectType = undefined;

  /** 条件值 */
  conditionValue = "";

  /** 运算符 */
  operatorName = "";

  /** 运算符类型 0:= 1:> 2:>= 3:< 4:<= */
  operatorType = undefined;
}

class LogisticsQuotationSurchargeInfoCreateDto {
  /** 计费模式 0:固定值 1：重量单价 2：超重部分单价 */
  billingMode = undefined;

  /** 计费对象类型 0：每票 1:每件 */
  billingObjectType = undefined;

  /** 费用值 */
  costValue = undefined;

  /** 费用类型ID 0:超重货件附加费、1:超长货件附加费、2:超大货件附加费 3:危险品附加费 4:偏远地区附加费 */
  feeTypeId = undefined;

  /** 费用类型名称 */
  feeTypeName = "";

  /** 最高费用 */
  maximumFee = undefined;

  /** 最低费用 */
  minimumFee = undefined;

  /** 物流报价-附加费信息-条件规则列表) */
  quotationSurchargeRuleList = [];
}

class LogisticsQuotationSurchargeInfoRequestDto {
  /** 计费模式 0:固定值 1：重量单价 2：超重部分单价 */
  billingMode = undefined;

  /** 计费对象类型 0：每票 1:每件 */
  billingObjectType = undefined;

  /** 费用值 */
  costValue = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 费用类型ID 0:超重货件附加费、1:超长货件附加费、2:超大货件附加费 3:危险品附加费 4:偏远地区附加费 */
  feeTypeId = undefined;

  /** 费用类型名称 */
  feeTypeName = "";

  /** id */
  id = undefined;

  /** 物流报价方案ID */
  logisticsQuotationId = undefined;

  /** 物流报价方案名称 */
  logisticsQuotationName = "";

  /** 最高费用 */
  maximumFee = undefined;

  /** 最低费用 */
  minimumFee = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsQuotationSurchargeInfoResponseDto {
  /** 计费模式 0:固定值 1：重量单价 2：超重部分单价 */
  billingMode = undefined;

  /** 计费对象类型 0：每票 1:每件 */
  billingObjectType = undefined;

  /** 费用值 */
  costValue = undefined;

  /** 费用类型ID 0:超重货件附加费、1:超长货件附加费、2:超大货件附加费 3:危险品附加费 4:偏远地区附加费 */
  feeTypeId = undefined;

  /** 费用类型名称 */
  feeTypeName = "";

  /** id */
  id = undefined;

  /** 物流报价方案ID */
  logisticsQuotationId = undefined;

  /** 物流报价方案名称 */
  logisticsQuotationName = "";

  /** 最高费用 */
  maximumFee = undefined;

  /** 最低费用 */
  minimumFee = undefined;

  /** 物流报价-附加费信息-条件规则列表) */
  quotationSurchargeRuleList = [];
}

class LogisticsQuotationSurchargeInfoUpdateDto {
  /** 计费模式 0:固定值 1：重量单价 2：超重部分单价 */
  billingMode = undefined;

  /** 计费对象类型 0：每票 1:每件 */
  billingObjectType = undefined;

  /** 费用值 */
  costValue = undefined;

  /** 费用类型ID 0:超重货件附加费、1:超长货件附加费、2:超大货件附加费 3:危险品附加费 4:偏远地区附加费 */
  feeTypeId = undefined;

  /** 费用类型名称 */
  feeTypeName = "";

  /** ID */
  id = undefined;

  /** 物流报价方案ID */
  logisticsQuotationId = undefined;

  /** 最高费用 */
  maximumFee = undefined;

  /** 最低费用 */
  minimumFee = undefined;

  /** 物流报价-附加费信息-条件规则列表) */
  quotationSurchargeRuleList = [];
}

class LogisticsQuotationSurchargeRuleCreateDto {
  /** 条件规则类型 0：所有 1：任一 */
  ruleType = undefined;

  /** surchargeFormulaList */
  surchargeFormulaList = [];
}

class LogisticsQuotationSurchargeRuleRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 物流报价方案ID */
  logisticsQuotationId = undefined;

  /** 条件规则类型 0：所有 1：任一 */
  ruleType = undefined;

  /** 附加费用信息ID */
  surchargeInfoId = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsQuotationSurchargeRuleResponseDto {
  /** id */
  id = undefined;

  /** 物流报价方案ID */
  logisticsQuotationId = undefined;

  /** 条件规则类型 0：所有 1：任一 */
  ruleType = undefined;

  /** surchargeFormulaList */
  surchargeFormulaList = [];

  /** 附加费用信息ID */
  surchargeInfoId = undefined;
}

class LogisticsQuotationSurchargeRuleUpdateDto {
  /** 条件规则类型 0：所有 1：任一 */
  ruleType = undefined;

  /** surchargeFormulaList */
  surchargeFormulaList = [];
}

class LogisticsQuotationTobRequestDto {
  /** 渠道服务编号 */
  channelCode = "";

  /** 计费类型 */
  chargeType = undefined;

  /** 渠道服务报价方案明细 */
  logisticsQuotationDetailTobRequestDtos = [];

  /** 渠道商编号 */
  providerCode = "";

  /** 报价方案编号 */
  quotationCode = "";

  /** 重量取值 */
  weightValue = undefined;
}

class LogisticsQuotationTobRequestParamsDto {
  /** 渠道服务编号 */
  channelCode = "";

  /** 计费类型 */
  chargeType = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 渠道商编号 */
  providerCode = "";

  /** 报价方案编号 */
  quotationCode = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 重量取值 */
  weightValue = undefined;
}

class LogisticsQuotationTobResponseDto {
  /** 渠道服务编号 */
  channelCode = "";

  /** 计费类型 */
  chargeType = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 渠道服务报价方案明细 */
  logisticsQuotationDetailTobResponseDtos = [];

  /** 渠道商编号 */
  providerCode = "";

  /** 报价方案编号 */
  quotationCode = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 重量取值 */
  weightValue = undefined;
}

class LogisticsQuotationUpdateDto {
  /** 燃油附加费比例% */
  fuelSurchargeProportion = undefined;

  /** id */
  id = undefined;

  /** 处理费 */
  processingFee = undefined;

  /** 运费折扣比例% */
  shippingDiscountProportion = undefined;
}

class LogisticsQuotationZoneCreateDto {
  /** 平均时效（天） */
  averageDay = undefined;

  /** 续重重量（g）如：50g */
  continuedWeight = undefined;

  /** 续重单价，如：美元/50g */
  continuedWeightPrice = undefined;

  /** 折扣比例% */
  discount = undefined;

  /** 结束重量段(g) */
  endWeight = undefined;

  /** 首重重量（g） */
  firstWeight = undefined;

  /** 首重费用 */
  firstWeightPrice = undefined;

  /** 杂费 */
  otherFee = undefined;

  /** 邮编范围止 */
  postcodeEnd = "";

  /** 邮编范围起 */
  postcodeStart = "";

  /** 挂号费 */
  registrationFee = undefined;

  /** 开始重量段（g） */
  startWeight = undefined;

  /** 目的国家简码 */
  targetCountryCode = "";

  /** 目的国家名称 */
  targetCountryName = "";

  /** 总价（在这个重量段的应收总金额） */
  totalPrice = undefined;

  /** 计价重量单位单价(如：每个计价单位5g的单价) */
  valuationWeightPrice = undefined;

  /** 计价重量单位（如：每5g算一个计价单位） */
  valuationWeightUnit = undefined;
}

class LogisticsQuotationZoneRequestDto {
  /** 平均时效（天） */
  averageDay = undefined;

  /** 续重重量（g）如：50g */
  continuedWeight = undefined;

  /** 续重单价，如：美元/50g */
  continuedWeightPrice = undefined;

  /** 折扣比例% */
  discount = undefined;

  /** 结束重量段(g) */
  endWeight = undefined;

  /** 首重重量（g） */
  firstWeight = undefined;

  /** 首重费用 */
  firstWeightPrice = undefined;

  /** id */
  id = undefined;

  /** 物流报价方案ID */
  logisticsQuotationId = undefined;

  /** 杂费 */
  otherFee = undefined;

  /** 邮编范围止 */
  postcodeEnd = "";

  /** 邮编范围起 */
  postcodeStart = "";

  /** 报价信息ID */
  quotationInfoId = undefined;

  /** 挂号费 */
  registrationFee = undefined;

  /** 开始重量段（g） */
  startWeight = undefined;

  /** 目的国家简码 */
  targetCountryCode = "";

  /** 目的国家名称 */
  targetCountryName = "";

  /** 总价（在这个重量段的应收总金额）单位：美元 */
  totalPrice = undefined;

  /** 计价重量单位单价：美元/kg */
  valuationWeightPrice = undefined;
}

class LogisticsQuotationZoneResponseDto {
  /** 平均时效（天） */
  averageDay = undefined;

  /** 续重重量（g）如：50g */
  continuedWeight = undefined;

  /** 续重单价，如：美元/50g */
  continuedWeightPrice = undefined;

  /** 折扣比例% */
  discount = undefined;

  /** 结束重量段(g) */
  endWeight = undefined;

  /** 首重重量（g） */
  firstWeight = undefined;

  /** 首重费用 */
  firstWeightPrice = undefined;

  /** id */
  id = undefined;

  /** 物流报价方案ID */
  logisticsQuotationId = undefined;

  /** 杂费 */
  otherFee = undefined;

  /** 邮编范围止 */
  postcodeEnd = "";

  /** 邮编范围起 */
  postcodeStart = "";

  /** 报价信息ID */
  quotationInfoId = undefined;

  /** 挂号费 */
  registrationFee = undefined;

  /** 开始重量段（g） */
  startWeight = undefined;

  /** 目的国家简码 */
  targetCountryCode = "";

  /** 目的国家名称 */
  targetCountryName = "";

  /** 总价（在这个重量段的应收总金额）单位：美元 */
  totalPrice = undefined;

  /** 计价重量单位单价：美元/kg */
  valuationWeightPrice = undefined;
}

class LogisticsQuotationZoneUpdateDto {
  /** 平均时效（天） */
  averageDay = undefined;

  /** 续重重量（g）如：50g */
  continuedWeight = undefined;

  /** 续重单价，如：美元/50g */
  continuedWeightPrice = undefined;

  /** 折扣比例% */
  discount = undefined;

  /** 结束重量段(g) */
  endWeight = undefined;

  /** 首重重量（g） */
  firstWeight = undefined;

  /** 首重费用 */
  firstWeightPrice = undefined;

  /** 杂费 */
  otherFee = undefined;

  /** 邮编范围止 */
  postcodeEnd = "";

  /** 邮编范围起 */
  postcodeStart = "";

  /** 挂号费 */
  registrationFee = undefined;

  /** 开始重量段（g） */
  startWeight = undefined;

  /** 目的国家简码 */
  targetCountryCode = "";

  /** 目的国家名称 */
  targetCountryName = "";

  /** 总价（在这个重量段的应收总金额）单位：美元 */
  totalPrice = undefined;

  /** 计价重量单位单价：美元/kg */
  valuationWeightPrice = undefined;
}

class LogisticsTariffThresholdCreateRequestDto {
  /** 货币单位 */
  currencyUnit = "";

  /** 起始国家简码 */
  originCountryCode = "";

  /** 起始国家 */
  originCountryName = "";

  /** 目标国家简码 */
  targetCountryCode = "";

  /** 目标国家 */
  targetCountryName = "";

  /** 起征点 */
  threshold = undefined;
}

class LogisticsTariffThresholdResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 货币单位 */
  currencyUnit = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 起始国家简码 */
  originCountryCode = "";

  /** 起始国家 */
  originCountryName = "";

  /** 目标国家简码 */
  targetCountryCode = "";

  /** 目标国家 */
  targetCountryName = "";

  /** 起征点 */
  threshold = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LogisticsTariffThresholdUpdateRequestDto {
  /** 货币单位 */
  currencyUnit = "";

  /** ID */
  id = undefined;

  /** 起始国家简码 */
  originCountryCode = "";

  /** 起始国家 */
  originCountryName = "";

  /** 目标国家简码 */
  targetCountryCode = "";

  /** 目标国家 */
  targetCountryName = "";

  /** 起征点 */
  threshold = undefined;
}

class MergeCustomsDeclarationRequestDto {
  /** 合并报关来源单号 */
  sourceNos = [];
}

class PageInfo {
  /** endRow */
  endRow = undefined;

  /** hasNextPage */
  hasNextPage = false;

  /** hasPreviousPage */
  hasPreviousPage = false;

  /** isFirstPage */
  isFirstPage = false;

  /** isLastPage */
  isLastPage = false;

  /** list */
  list = [];

  /** navigateFirstPage */
  navigateFirstPage = undefined;

  /** navigateLastPage */
  navigateLastPage = undefined;

  /** navigatePages */
  navigatePages = undefined;

  /** navigatepageNums */
  navigatepageNums = [];

  /** nextPage */
  nextPage = undefined;

  /** pageNum */
  pageNum = undefined;

  /** pageSize */
  pageSize = undefined;

  /** pages */
  pages = undefined;

  /** prePage */
  prePage = undefined;

  /** size */
  size = undefined;

  /** startRow */
  startRow = undefined;

  /** total */
  total = undefined;
}

class PayRequestPartialPaymentDto {
  /** 费用列表 */
  costRequestId = [];

  /** 请款付款明细表 */
  paymentDetailBean = new PaymentDetailBean();

  /** 付款单号 */
  payno = "";
}

class PayRequestResultDto {
  /** 工作流 */
  activitiApplyRequestDto = new ActivitiApplyRequestDto();

  /** 费用列表 */
  costRequestId = [];

  /** 付款时间 */
  paidTime = "";

  /** 请款付款明细表 */
  paymentToDetailRequestDto = new PaymentToDetailRequestDto();

  /** 付款单号 */
  payno = "";

  /** 用途 */
  purpose = "";

  /** 备注 */
  remark = "";
}

class PayUploadBillFileRequestDto {
  /** 水单附件 */
  billFile = "";

  /** 付款单号 */
  payno = "";
}

class PayUploadFileRequestDto {
  /** 发起人 */
  initiator = "";

  /** 付款单号 */
  payno = "";

  /** 请款附件 */
  requestFile = "";
}

class PaymentDetailBean {
  /** 水单附件 */
  billFile = "";

  /** 付款银行编号 */
  paymentBankCode = "";

  /** 付款银行名称 */
  paymentBankName = "";

  /** 备注 */
  remark = "";
}

class PaymentDetailRequestParamsDto {
  /** 水单附件 */
  billFile = "";

  /** 单据序列号 */
  billSerialNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 付款金额 */
  paidAmount = undefined;

  /** 付款银行编号 */
  paymentBankCode = "";

  /** 付款银行名称 */
  paymentBankName = "";

  /** 付款单号 */
  payno = "";

  /** 备注 */
  remark = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class PaymentMasterRequestParamsDto {
  /** 是否预付款 0否 1是 */
  advanceFlag = undefined;

  /** 是否存在水单附件 0：否 1：是 */
  annexFlag = false;

  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** 是否作废 0否 1是 */
  cancelFlag = undefined;

  /** 作废备注 */
  cancelRemake = "";

  /** 是否cbs付款 0：否 1：是 */
  cbsPaymentFlag = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 请款时间-结束 */
  createTimeEnd = "";

  /** 请款时间-开始 */
  createTimeStart = "";

  /** 币种 */
  currency = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前处理人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 汇率 */
  exchangeRate = undefined;

  /** id */
  id = undefined;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 已付金额 */
  paidAmount = undefined;

  /** 付款时间 */
  paidTime = "";

  /** 付款时间-结束 */
  paidTimeEnd = "";

  /** 付款时间-开始 */
  paidTimeStart = "";

  /** 应付金额 */
  payableAmount = undefined;

  /** 收款人名称 */
  payeeAccountName = "";

  /** 收款人开户行 */
  payeeBankName = "";

  /** 收款人银行账户 */
  payeeBankNumber = "";

  /** 收款方编号 */
  payeeCode = "";

  /** 收款方名称 */
  payeeName = "";

  /** 付款方主体编号 */
  payerCompanyCode = "";

  /** 付款方主体名称 */
  payerCompanyName = "";

  /** 付款单号 */
  payno = "";

  /** pay单号多选，英文逗号分隔 */
  paynoIn = "";

  /** 用途 */
  purpose = "";

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回原因 */
  rejectTimeReason = "";

  /** 驳回人 */
  rejector = "";

  /** 备注 */
  remark = "";

  /** 请款附件 */
  requestFile = "";

  /** 状态：10 审批中，20 已驳回，30 部分付款，40 已付款 */
  status = undefined;

  /** 订单状态多选，英文逗号分隔 */
  statusIn = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 供应商内部代码 */
  vendorInternalCode = "";
}

class PaymentMasterResponseDto {
  /** 是否预付款 0否 1是 */
  advanceFlag = undefined;

  /** 是否存在水单附件 */
  annexFlag = false;

  /** 审批意见 */
  approvalSug = "";

  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** 业务参考号 */
  businessReferenceNumber = "";

  /** 是否作废 0否 1是 */
  cancelFlag = undefined;

  /** 作废备注 */
  cancelRemake = "";

  /** CBS 单据号 */
  cbsDocumentNumber = "";

  /** 是否cbs付款 0：否 1：是 */
  cbsPaymentFlag = undefined;

  /** 付款用途 */
  cbsRemark = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前处理人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 汇率 */
  exchangeRate = undefined;

  /** id */
  id = undefined;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 是否国内银行 0:否 1:是 */
  isDomesticBank = undefined;

  /** 已付金额 */
  paidAmount = undefined;

  /** 付款时间 */
  paidTime = "";

  /** 应付金额 */
  payableAmount = undefined;

  /** 收款人名称 */
  payeeAccountName = "";

  /** 收款人开户行 */
  payeeBankName = "";

  /** 收款人银行账户 */
  payeeBankNumber = "";

  /** 收款方编号 */
  payeeCode = "";

  /** 收款方名称 */
  payeeName = "";

  /** 付款方主体编号 */
  payerCompanyCode = "";

  /** 付款方主体名称 */
  payerCompanyName = "";

  /** 付款单号 */
  payno = "";

  /** 用途 */
  purpose = "";

  /** 收款账户名 */
  recipientAccountName = "";

  /** 收款账号 */
  recipientAccountNumber = "";

  /** 收款开户市 */
  recipientBankCity = "";

  /** 收款银行名称 */
  recipientBankName = "";

  /** 收款开户省 */
  recipientBankProvince = "";

  /** 收款开户行 */
  recipientOpeningBankName = "";

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回原因 */
  rejectTimeReason = "";

  /** 驳回人 */
  rejector = "";

  /** 备注 */
  remark = "";

  /** 请款附件 */
  requestFile = "";

  /** 状态：10 审批中，20 已驳回，30 部分付款，40 已付款 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 供应商内部代码 */
  vendorInternalCode = "";
}

class PaymentToDetailRequestDto {
  /** 账户性质 */
  accountNature = "";

  /** 水单附件 */
  billFile = "";

  /** CBS单据号 */
  cbsDocumentNumber = "";

  /** CBS付款标识 0:否 1:是 */
  cbsPaymentFlag = undefined;

  /** CBS付款用途 */
  cbsRemark = "";

  /** 企业号 */
  companyNumber = "";

  /** 付款帐户名 */
  paymentBankAccountName = "";

  /** 付款账号 */
  paymentBankAccountNum = "";

  /** 付款分行/开户行名称 */
  paymentBankBranchName = "";

  /** 付款分行/开户行编号 */
  paymentBankBranchNum = "";

  /** 付款开户市 */
  paymentBankCity = "";

  /** 付款银行编号 */
  paymentBankCode = "";

  /** 付款银行名称 */
  paymentBankName = "";

  /** 付款开户省 */
  paymentBankProvince = "";
}

class PlatformLogisticsRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 平台邮寄方式编号 */
  platformPostCode = "";

  /** 平台邮寄方式名称 */
  platformPostName = "";

  /** 备注 */
  remark = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class PlatformLogisticsResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 平台邮寄方式编号 */
  platformPostCode = "";

  /** 平台邮寄方式名称 */
  platformPostName = "";

  /** 备注 */
  remark = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new CabinAdvanceMasterResponseDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class SiteEfficiencyMasterRequestDto {
  /** 区域 */
  area = "";

  /** 时效天数 */
  efficiencyDay = undefined;

  /** 时效类型 1.超时时效设置，2.预签收时效设置 */
  efficiencyType = undefined;

  /** id */
  id = undefined;

  /** 物流方式：1 龙舟空运 ，2 龙舟海运 ，10 普通空运 ，20 普通海运 ，30 快船 ，40 铁路 ，50 卡车，60 快递 */
  logisticsType = undefined;

  /** 站点标识 */
  site = "";
}

class SiteEfficiencyMasterResponseDto {
  /** 区域 */
  area = "";

  /** 时效天数 */
  efficiencyDay = undefined;

  /** 时效类型 */
  efficiencyType = undefined;

  /** 时效设置主表id */
  id = undefined;

  /** 物流类型：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车  */
  logisticsType = undefined;

  /** 站点标识 */
  site = "";
}

class StartPortRequestDto {
  /** 区域 */
  area = "";

  /** 城市 */
  city = "";

  /** 城市编码 */
  cityCode = "";

  /** 国家 */
  country = "";

  /** 国家编码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0：否 >0:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 省份 */
  province = "";

  /** 省份编码 */
  provinceCode = "";

  /** 起运港地址 */
  startPortAddress = "";

  /** 起运港编号 */
  startPortCode = "";

  /** 起运港名称 */
  startPortName = "";

  /** 使用状态 1：启用 0：停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 邮编 */
  zipCode = "";
}

class StartPortRequestParamsDto {
  /** 区域 */
  area = "";

  /** 城市 */
  city = "";

  /** 城市编码 */
  cityCode = "";

  /** 国家 */
  country = "";

  /** 国家编码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 创建时间-结束 */
  createTimeEnd = "";

  /** 创建时间-开始 */
  createTimeStart = "";

  /** 删除标识 0：否 >0:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 省份 */
  province = "";

  /** 省份编码 */
  provinceCode = "";

  /** 起运港地址 */
  startPortAddress = "";

  /** 起运港编号 */
  startPortCode = "";

  /** 起运港名称 */
  startPortName = "";

  /** 使用状态 1：启用 0：停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 邮编 */
  zipCode = "";
}

class StartPortResponseDto {
  /** 区域 */
  area = "";

  /** 城市 */
  city = "";

  /** 城市编码 */
  cityCode = "";

  /** 国家 */
  country = "";

  /** 国家编码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0：否 >0:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 省份 */
  province = "";

  /** 省份编码 */
  provinceCode = "";

  /** 起运港地址 */
  startPortAddress = "";

  /** 起运港编号 */
  startPortCode = "";

  /** 起运港名称 */
  startPortName = "";

  /** 使用状态 1：启用 0：停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 邮编 */
  zipCode = "";
}

class StockOccupyDetailResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 报关单价 */
  declarePrice = undefined;

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 汇率 */
  exchangeRate = undefined;

  /** id */
  id = undefined;

  /** 占用数量 */
  occupyQty = undefined;

  /** 操作单号 */
  operationNo = "";

  /** 操作单据类型 10:出库 20:调拨 30:盘点 40:报损 */
  operationType = undefined;

  /** 采购单号 */
  pono = "";

  /** 单价 */
  price = undefined;

  /** 行号 */
  rowNo = undefined;

  /** sku */
  sku = "";

  /** 税率 */
  taxRate = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockOccupyForBillRequestDto {
  /** 调拨批次号 */
  abno = "";

  /** 操作单号 */
  operationNo = "";

  /** 操作单据类型 10:出库 20:调拨 30:盘点 40:报损 */
  operationType = undefined;

  /** 是否销售tob订单 */
  salesOrderTobFlag = false;

  /** SKU明细 */
  skuDtos = [];

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockOccupyForBillSkuRequestDto {
  /** pono */
  pono = "";

  /** 数量 */
  qty = undefined;

  /** rowNo */
  rowNo = undefined;

  /** sku */
  sku = "";
}

class StockOccupyMasterAddRequestDto {
  /** 采购单号 */
  pono = "";

  /** SKU明细 */
  skuDtos = [];

  /** 税率 */
  taxRate = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockOccupyMasterResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 采购单号 */
  pono = "";

  /** 单价 */
  price = undefined;

  /** 总数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 税率 */
  taxRate = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 可占用数量 */
  useQty = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockOccupyMasterResponseRpcDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 采购单号 */
  pono = "";

  /** 单价 */
  price = undefined;

  /** 总数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 可占用数量 */
  useQty = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockOccupyMasterSelectRequestDto {
  /** 采购单号 */
  pono = "";

  /** sku集合 */
  skuPrice = [];

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** warehoseCodes */
  warehoseCodes = [];

  /** 仓库编号 */
  warehouseCode = "";
}

class StockOccupyMasterSelectSkuRequestDto {
  /** 价格 */
  price = undefined;

  /** sku */
  sku = "";
}

class StockOccupySkuAddRequestDto {
  /** pono */
  pono = "";

  /** 单价 */
  price = undefined;

  /** 总数量 */
  qty = undefined;

  /** rowNo */
  rowNo = undefined;

  /** sku */
  sku = "";
}

class SupplierSkuDeliverableResponseRpcDto {
  /** 可交数量 */
  deliverableQty = undefined;

  /** sku编号 */
  skuNo = "";

  /** 供应商编码 */
  supplierCode = "";

  /** 交易主体简码 */
  tradeCompanyCode = "";
}

class TariffThresholdResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 货币单位 */
  currencyUnit = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 起始国家简码 */
  originCountryCode = "";

  /** 起始国家 */
  originCountryName = "";

  /** 目标国家简码 */
  targetCountryCode = "";

  /** 目标国家 */
  targetCountryName = "";

  /** 起征点 */
  threshold = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class TaskDto {
  /** 节点编码 */
  nodeKey = "";

  /** 节点名称 */
  nodeName = "";

  /** 任务id */
  taskId = "";
}

class TaxRefundMatchingRequestDto {
  /** 调拨单号 */
  aono = "";

  /** 调拨单sku数量 */
  aonoSkuQty = undefined;

  /** 退税匹配批次号 */
  batchNumber = "";

  /** 认证日期 */
  certificationTime = "";

  /** 报关合同号 */
  contractNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 报关主体编码 */
  ebsId = "";

  /** 主键id */
  id = undefined;

  /** 发票单据编码No */
  invNo = "";

  /** 发票代码 */
  invoiceCode = "";

  /** 开票品名 */
  invoiceName = "";

  /** 发票号 */
  invoiceNumber = "";

  /** 开票日期 */
  invoiceTime = "";

  /** 发票单位 */
  invoiceUnitName = "";

  /** 版本 */
  lockVersion = undefined;

  /** 物流发运时间 */
  logisticsDeliveryTime = "";

  /** 匹配状态 0 未匹配  1 部分匹配  2 全部匹配 */
  matchedStatusIn = "";

  /** po单号 */
  pono = "";

  /** sku品名 */
  productName = "";

  /** sku单位 */
  productUnitName = "";

  /** po含税单价 */
  purchasePrice = undefined;

  /** sku数量 */
  qty = undefined;

  /** 实际开票含税单价 */
  realInvoicingUnitPrice = undefined;

  /** 红票匹配数量 */
  redMatchinQty = undefined;

  /** 备注 */
  remark = "";

  /** 行号 */
  rowNo = undefined;

  /** sku编码 */
  sku = "";

  /** sku匹配数量 */
  skuMatchinQty = undefined;

  /** 报关明细号 */
  subContractNo = "";

  /** 报关明细号 */
  subContractNoIn = "";

  /** 报关单编号 */
  suitableContractNo = "";

  /** 供应商编码 */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 税率 */
  taxRate = undefined;

  /** 是否可退税 0否 1是 */
  taxRefundEligible = undefined;

  /** 退税状态 0未退税 1 已退税 2 无法退税 */
  taxRefundStatusIn = "";

  /** 报关主体名称 */
  transactionMainNameIn = "";

  /** 报关类型：10：内部调拨 20：销售订单 */
  type = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 出口年份 */
  year = "";
}

class TaxRefundMatchingResponseDto {
  /** 调拨单号 */
  aono = "";

  /** 调拨单sku数量 */
  aonoSkuQty = undefined;

  /** 退税匹配批次号 */
  batchNumber = "";

  /** 认证日期 */
  certificationTime = "";

  /** 报关合同号 */
  contractNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 报关主体编码 */
  ebsId = "";

  /** 主键id */
  id = undefined;

  /** 发票单据编码No */
  invNo = "";

  /** 发票代码 */
  invoiceCode = "";

  /** 开票品名 */
  invoiceName = "";

  /** 发票号 */
  invoiceNumber = "";

  /** 发票sku数量 */
  invoiceQty = undefined;

  /** 开票日期 */
  invoiceTime = "";

  /** 发票类型 10 蓝票  20 红票 */
  invoiceType = "";

  /** 发票单位 */
  invoiceUnitName = "";

  /** 版本 */
  lockVersion = undefined;

  /** 物流发运时间 */
  logisticsDeliveryTime = "";

  /** 匹配状态 0 未匹配  1 部分匹配  2 全部匹配 */
  matchedStatus = undefined;

  /** po单号 */
  pono = "";

  /** sku品名 */
  productName = "";

  /** sku单位 */
  productUnitName = "";

  /** po含税单价 */
  purchasePrice = undefined;

  /** po不含税单价 */
  purchasePriceExcludeTax = undefined;

  /** po含税金额 */
  purchasePriceTotal = undefined;

  /** sku数量 */
  qty = undefined;

  /** 实际开票含税单价 */
  realInvoicingUnitPrice = undefined;

  /** 实际开票不含税单价 */
  realInvoicingUnitPriceExcludeTax = undefined;

  /** 实际开票不含税金额 */
  realInvoicingUnitPriceExcludeTaxTotal = undefined;

  /** 实际开票含税金额 */
  realInvoicingUnitPriceTotal = undefined;

  /** 红票匹配数量 */
  redMatchinQty = undefined;

  /** 备注 */
  remark = "";

  /** 行号 */
  rowNo = undefined;

  /** sku编码 */
  sku = "";

  /** sku匹配数量 */
  skuMatchinQty = undefined;

  /** 报关明细号 */
  subContractNo = "";

  /** 报关单编号 */
  suitableContractNo = "";

  /** 供应商编码 */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 税率 */
  taxRate = undefined;

  /** 是否可退税 */
  taxRefundEligible = undefined;

  /** 退税状态 0 未退税 1 已退税 2 无法退税 */
  taxRefundStatus = undefined;

  /** 报关主体名称 */
  transactionMainName = "";

  /** 报关类型：10：内部调拨 20：销售订单 */
  type = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 出口年份 */
  year = "";
}

class ToLogisticsChannelResponseDto {
  /** 调拨单号 */
  aono = "";

  /** 渠道编号 */
  channelCode = "";

  /** 渠道名称 */
  channelName = "";

  /** 渠道英文名称 */
  channelNameEn = "";

  /** 物流商编号 */
  providerCode = "";

  /** 物流商名称 */
  providerName = "";

  /** 状态 1:启用 0:停用 */
  status = undefined;
}

class TransportBillDetailRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** hscode */
  hscode = "";

  /** id */
  id = undefined;

  /** 品名 */
  productName = "";

  /** 备注 */
  remark = "";

  /** TMS单号 */
  tmsno = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class TransportBillDetailResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** hscode */
  hscode = "";

  /** id */
  id = undefined;

  /** 品名 */
  productName = "";

  /** 备注 */
  remark = "";

  /** TMS单号 */
  tmsno = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class TransportCourierDetailRequestDto {
  /** 快递单号 */
  courierNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 备注 */
  remark = "";

  /** TMS单号 */
  tmsno = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class TransportCourierDetailResponseDto {
  /** 快递单号 */
  courierNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 备注 */
  remark = "";

  /** TMS单号 */
  tmsno = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class TransportDbdRequestDto {
  /** 箱重 */
  boxWeight = undefined;

  /** 是否自拖自报 0:否 1:是 */
  byselfFlag = undefined;

  /** 货柜号 */
  containerNo = "";

  /** 目的港 */
  endPort = "";

  /** 截关日期 */
  endTariffTime = "";

  /** 装柜备注 */
  loadCabinRemark = "";

  /** 物流方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车 */
  logisticsType = undefined;

  /** 封条号 */
  sealno = "";

  /** TMS单号 */
  tmsno = "";

  /** 过磅重量 */
  weighing = undefined;
}

class TransportDblRequestDto {
  /** 计费重 */
  billingWeight = undefined;

  /** 船公司 */
  boatCompany = "";

  /** 箱数 */
  boxQty = undefined;

  /** 箱重 */
  boxWeight = undefined;

  /** 是否自拖自报 0:否 1:是 */
  byselfFlag = undefined;

  /** consignee */
  consignee = "";

  /** 货柜号 */
  containerNo = "";

  /** 报关代理 */
  declareAgent = "";

  /** 报关代理编码 */
  declareAgentCode = "";

  /** 目的港 */
  endPort = "";

  /** 截关日期 */
  endTariffTime = "";

  /** 尾程配送方式 */
  finalDelivery = undefined;

  /** 提单附件 */
  ladingBillFile = "";

  /** 装柜备注 */
  loadCabinRemark = "";

  /** 渠道服务编号 */
  logisticsChannelCode = "";

  /** 渠道服务名称 */
  logisticsChannelName = "";

  /** 渠道商编号 */
  logisticsProviderCode = "";

  /** 渠道商名称 */
  logisticsProviderName = "";

  /** 物流方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车 */
  logisticsType = undefined;

  /** 包装单位；10 CTNS,20 PLTS */
  packingUnit = undefined;

  /** 数量 */
  qty = undefined;

  /** 封条号 */
  sealno = "";

  /** shipper */
  shipper = "";

  /** 店铺信息 */
  shopMessage = "";

  /** SO号 */
  soNo = "";

  /** 是否包税 */
  taxInclusiveFlag = undefined;

  /** TMS单号 */
  tmsno = "";

  /** 拖车代理 */
  trailerAgent = "";

  /** 拖车代理编码 */
  trailerAgentCode = "";

  /** 提单信息 */
  transportBillDetailRequestDtos = [];

  /** 车牌信息 */
  transportLicensePlateRequest = new TransportLicensePlateRequestDto();

  /** 供应商内部代码 */
  vendorInternalCode = "";

  /** 体积 */
  volume = undefined;

  /** 运单号 */
  waybillNo = "";

  /** 过磅重量 */
  weighing = undefined;

  /** 重量 */
  weight = undefined;
}

class TransportDckRequestDto {
  /** 出口报关附件 */
  exportDeclarationFile = "";

  /** 放行时间 */
  releaseTime = "";

  /** TMS单号 */
  tmsno = "";
}

class TransportDjfRequestDto {
  /** 计费单位 */
  billingUnit = "";

  /** 计费重 */
  billingWeight = undefined;

  /** TMS单号 */
  tmsno = "";
}

class TransportDjkRequestDto {
  /** 进口清关附件 */
  importClearanceFile = "";

  /** 进口清关完成时间 */
  importClearanceTime = "";

  /** TMS单号 */
  tmsno = "";
}

class TransportDjsRequestDto {
  /** 账单时间 */
  billTime = "";

  /** 预估结算时间 */
  estimateSettlementTime = "";

  /** 结算金额 */
  settlementAmount = "";

  /** 结算币种 */
  settlementCurrency = "";

  /** 结算汇率 */
  settlementExchangeRate = undefined;

  /** 结算信息附件 */
  settlementFile = "";

  /** TMS单号 */
  tmsno = "";
}

class TransportDlrRequestDto {
  /** 出口报关单号 */
  exportDeclarationNo = "";

  /** 实际报关合同号 */
  suitableContractNo = "";

  /** TMS单号 */
  tmsno = "";

  /** 开票信息 */
  transportSkuDetailRequestDtos = [];
}

class TransportDpodRequestDto {
  /** pod上传附件 */
  podFile = "";

  /** 海外pod签收时间 */
  podSignTime = "";

  /** TMS单号 */
  tmsno = "";

  /** 物流快递信息 */
  transportCourierDetailRequestDtos = [];
}

class TransportDraftBoxMasterRequestDto {
  /** 账单时间 */
  billTime = "";

  /** 计费单位 */
  billingUnit = "";

  /** 计费重 */
  billingWeight = undefined;

  /** 船公司 */
  boatCompany = "";

  /** 箱数 */
  boxQty = undefined;

  /** 箱重 */
  boxWeight = undefined;

  /** 是否自拖自报 0:否 1:是 */
  byselfFlag = undefined;

  /** consignee */
  consignee = "";

  /** 货柜号 */
  containerNo = "";

  /** 报关代理 */
  declareAgent = "";

  /** 报关代理编码 */
  declareAgentCode = "";

  /** 目的港 */
  endPort = "";

  /** 截关日期 */
  endTariffTime = "";

  /** 预估结算时间 */
  estimateSettlementTime = "";

  /** 出口报关附件 */
  exportDeclarationFile = "";

  /** 出口报关单号 */
  exportDeclarationNo = "";

  /** 尾程配送方式 1.卡派，2.快递派 */
  finalDelivery = "";

  /** 进口清关附件 */
  importClearanceFile = "";

  /** 进口清关完成时间 */
  importClearanceTime = "";

  /** 提单附件 */
  ladingBillFile = "";

  /** 装柜备注 */
  loadCabinRemark = "";

  /** 渠道服务编号 */
  logisticsChannelCode = "";

  /** 渠道服务名称 */
  logisticsChannelName = "";

  /** 渠道商编号 */
  logisticsProviderCode = "";

  /** 渠道商名称 */
  logisticsProviderName = "";

  /** 物流方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车 */
  logisticsType = undefined;

  /** 包装单位；10 CTNS,20 PLTS */
  packingUnit = undefined;

  /** pod上传附件 */
  podFile = "";

  /** 海外pod签收时间 */
  podSignTime = "";

  /** 数量 */
  qty = undefined;

  /** 放行时间 */
  releaseTime = "";

  /** 封条号 */
  sealno = "";

  /** 结算金额 */
  settlementAmount = "";

  /** 结算信息附件 */
  settlementFile = "";

  /** shipper */
  shipper = "";

  /** 店铺信息 */
  shopMessage = "";

  /** SO号 */
  soNo = "";

  /** 实际报关合同号 */
  suitableContractNo = "";

  /** TMS单号 */
  tmsno = "";

  /** 拖车代理 */
  trailerAgent = "";

  /** 拖车代理编码 */
  trailerAgentCode = "";

  /** 提单信息 */
  transportBillDetailRequestDtos = [];

  /** 物流快递信息 */
  transportCourierDetailRequestDtos = [];

  /** 车牌信息 */
  transportLicensePlateRequest = new TransportLicensePlateRequestDto();

  /** 开票信息 */
  transportSkuDetailRequestDtos = [];

  /** 供应商内部代码 */
  vendorInternalCode = "";

  /** 体积 */
  volume = undefined;

  /** 运单号 */
  waybillNo = "";

  /** 过磅重量 */
  weighing = undefined;

  /** 重量 */
  weight = undefined;
}

class TransportFinanceDetailReportResponseDto {
  /** 操作单号 TO或者OQ */
  aono = "";

  /** 品牌 */
  brandName = "";

  /** 柜号 */
  containerNo = "";

  /** 出口报关合同号 */
  contractNo = "";

  /** 贸易国 */
  country = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 美元申报单价 */
  declareDollarPrice = undefined;

  /** 品名 */
  declareName = "";

  /** 进项税额 */
  differencePrice = undefined;

  /** 换汇成本 */
  exchangeCost = undefined;

  /** 申报汇率 */
  exchangeRate = undefined;

  /** 单据日期 */
  exportDeclarationTime = "";

  /** 采购含税金额 */
  hsAmount = undefined;

  /** ID */
  id = undefined;

  /** 运输方式 */
  logisticsName = "";

  /** 物流商 */
  logisticsProviderName = "";

  /** 匹配状态 0 未匹配  1 部分匹配  2 全部匹配 */
  matchedStatus = undefined;

  /** 型号 */
  model = "";

  /** PO号 */
  pono = "";

  /** 采购含税单价 */
  price = undefined;

  /** 加成比例 */
  priceIncreaseRatio = undefined;

  /** 数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** 行号 */
  rowNo = undefined;

  /** SKU */
  sku = "";

  /** sku已匹配数量 */
  skuMatchedQuantity = undefined;

  /** 货源地 */
  sourceGoods = "";

  /** TMS单号 */
  sourceNo = "";

  /** 报关明细号 */
  subContractNo = "";

  /** 出口报关单号 */
  suitableContractNo = "";

  /** 供应商编码 */
  supplierCode = "";

  /** 供应商 */
  supplierName = "";

  /** 税率 */
  taxRate = undefined;

  /** 是否可退税 */
  taxRefundEligible = undefined;

  /** 退税状态 0 未退税 1 已退税 2 无法退税 */
  taxRefundStatus = undefined;

  /** tms单号 */
  tmsno = "";

  /** 美元总价 */
  totalDollarPrice = undefined;

  /** 主体 */
  tradeCompanyName = "";

  /** 调拨类型 */
  type = undefined;

  /** 采购不含税金额 */
  unHsAmount = undefined;

  /** 采购不含税单价 */
  unHsPrice = undefined;

  /** 单位 */
  unitName = "";

  /** 更新时间 */
  updateTime = "";

  /** 物流单号/BO号 */
  waybillNo = "";
}

class TransportFinanceDetailRequestParamsDto {
  /** 调拨单号 */
  aono = "";

  /** 装箱重量 */
  boxWeight = undefined;

  /** 品牌 */
  brandName = "";

  /** bu名称 */
  buName = "";

  /** 合同号 */
  contractNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 创建时间-结束 */
  createTimeEnd = "";

  /** 创建时间-开始 */
  createTimeStart = "";

  /** 申报要素 */
  declareMemo = "";

  /** 品名 */
  declareName = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 商品编号 */
  hscodeCn = "";

  /** id */
  id = undefined;

  /** 进项号 */
  invoiceNumber = "";

  /** 匹配状态 0 未匹配  1 部分匹配  2 全部匹配多选，英文逗号分隔 */
  matchedStatusIn = "";

  /** 产品型号 */
  model = "";

  /** mpq */
  mpq = undefined;

  /** po单号 */
  pono = "";

  /** 单价 */
  price = undefined;

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 子合同号 */
  subContractNo = "";

  /** 报关合同号 */
  suitableContractNo = "";

  /** 供应商id */
  supplierIdName = "";

  /** 税率 */
  taxRate = undefined;

  /** 是否可退税 0否 1是 */
  taxRefundEligible = "";

  /** 退税状态 0 未退税 1 已退税 2 无法退税多选，英文逗号分隔 */
  taxRefundStatusIn = "";

  /** tms单号 */
  tmsno = "";

  /** 单位 */
  unitName = "";

  /** 更新人 */
  updateBy = "";

  /** update_time */
  updateTime = "";

  /** 更新时间-结束 */
  updateTimeEnd = "";

  /** 更新时间-开始 */
  updateTimeStart = "";

  /** 物流单号 */
  waybillNo = "";
}

class TransportLicensePlateRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 主键id */
  id = undefined;

  /** 装柜目的地 */
  loadingDestination = "";

  /** 装柜车牌 */
  loadingLicensePlate = "";

  /** 装柜起运地 */
  loadingShippingLocation = "";

  /** 版本 */
  lockVersion = undefined;

  /** 提货目的地 */
  pickUpDestination = "";

  /** 提货车牌 */
  pickUpLicensePlate = "";

  /** 提货起运地 */
  pickUpShippingLocation = "";

  /** TMS单号 */
  tmsno = "";

  /** 中转目的地(多个用/隔开) */
  transitDestination = "";

  /** 中转车牌(多个用/隔开) */
  transitLicensePlate = "";

  /** 中转起运地(多个用/隔开) */
  transitShippingLocation = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class TransportLicensePlateResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 主键id */
  id = undefined;

  /** 装柜目的地 */
  loadingDestination = "";

  /** 装柜车牌 */
  loadingLicensePlate = "";

  /** 装柜起运地 */
  loadingShippingLocation = "";

  /** 版本 */
  lockVersion = undefined;

  /** 提货目的地 */
  pickUpDestination = "";

  /** 提货车牌 */
  pickUpLicensePlate = "";

  /** 提货起运地 */
  pickUpShippingLocation = "";

  /** TMS单号 */
  tmsno = "";

  /** 中转目的地(多个用/隔开) */
  transitDestination = "";

  /** 中转车牌(多个用/隔开) */
  transitLicensePlate = "";

  /** 中转起运地(多个用/隔开) */
  transitShippingLocation = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class TransportMasterRequestParamsDto {
  /** 调拨批次单号 */
  abno = "";

  /** 实际签收时间 */
  actualSignTime = "";

  /** 实际签收时间IsNull */
  actualSignTimeIsNull = "";

  /** TO单号 */
  aoNo = "";

  /** 到仓时间 */
  arriveWarehouseTime = "";

  /** ATA */
  ataTime = "";

  /** ATAIsNull */
  ataTimeIsNull = "";

  /** ATD */
  atdTime = "";

  /** ATDIsNull */
  atdTimeIsNull = "";

  /** 账单时间 */
  billTime = "";

  /** 计费重 */
  billingWeight = undefined;

  /** 船公司 */
  boatCompany = "";

  /** 箱数 */
  boxQty = undefined;

  /** 箱重 */
  boxWeight = undefined;

  /** 是否自拖自报 0:否 1:是 */
  byselfFlag = undefined;

  /** 类型：10 工厂整柜，20 工厂散货，30 自营整柜，40 自营散货 */
  cabinType = undefined;

  /** centerId */
  centerId = "";

  /** consignee */
  consignee = "";

  /** 货柜号 */
  containerNo = "";

  /** 报关合同号 */
  contractNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 创建时间-结束 */
  createTimeEnd = "";

  /** 创建时间-开始 */
  createTimeStart = "";

  /** 订舱需求号 */
  crno = "";

  /** 币种 */
  currency = "";

  /** 清关完成时间 */
  customsClearanceTime = "";

  /** 报关专员 */
  customsCommissioner = "";

  /** 关单明细号 */
  customsDeclarationDetailNo = "";

  /** 是否查验 0.否 1.国外，2.国内 */
  customsInspectionFlag = undefined;

  /** 报关专员 */
  declarationOwner = "";

  /** 报关代理 */
  declareAgent = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 发运时间-结束 */
  deliveryTimeEnd = "";

  /** 发运时间-开始 */
  deliveryTimeStart = "";

  /** 是否为草稿 0:否 1:是 */
  draftFlag = undefined;

  /** 截单日期 */
  endBillTime = "";

  /** 目的港 */
  endPort = "";

  /** 截关日期 */
  endTariffTime = "";

  /** 预估结算时间 */
  estimateSettlementTime = "";

  /** 预计签收时间 */
  estimateSignTime = "";

  /** 预估运费 */
  estimatedFreight = undefined;

  /** ETA */
  etaTime = "";

  /** ETD */
  etdTime = "";

  /** 汇率 */
  exchangeRate = undefined;

  /** 出口报关附件 */
  exportDeclarationFile = "";

  /** 出口报关单号 */
  exportDeclarationNo = "";

  /** 出口报关完成时间 */
  exportDeclarationTime = "";

  /** 提取时间 */
  extractTime = "";

  /** 提取时间IsNull */
  extractTimeIsNull = "";

  /** id */
  id = undefined;

  /** 进口清关附件 */
  importClearanceFile = "";

  /** 进口清关提交时间 */
  importClearanceSubmitTime = "";

  /** 进口清关完成时间 */
  importClearanceTime = "";

  /** 进口清关完成时间IsNull */
  importClearanceTimeIsNull = "";

  /** 提单附件 */
  ladingBillFile = "";

  /** 装柜地址 */
  loadCabinAddress = "";

  /** 装柜备注 */
  loadCabinRemark = "";

  /** 装柜类型: 10 散货,20 20GP,30 40HQ, 40 40GP */
  loadCabinType = undefined;

  /** 渠道服务编号 */
  logisticsChannelCode = "";

  /** 渠道服务名称 */
  logisticsChannelName = "";

  /** 物流发运时间-结束 */
  logisticsDeliveryTimeEnd = "";

  /** 物流发运时间-开始 */
  logisticsDeliveryTimeStart = "";

  /** 物流专员 */
  logisticsOwner = "";

  /** 渠道商编号 */
  logisticsProviderCode = "";

  /** 渠道商名称 */
  logisticsProviderName = "";

  /** 物流信息 */
  logisticsTrackingInfo = "";

  /** 物流备注 */
  logisticsTrackingRemark = "";

  /** 物流跟踪状态多选 */
  logisticsTrackingStatusIn = "";

  /** 物流方式：1 龙舟空运，2 龙舟海运，10 普通空运，20 普通海运，30 快船，40 铁路，50 卡车 */
  logisticsType = undefined;

  /** 包装单位；10 CTNS,20 PLTS */
  packingUnit = undefined;

  /** 已付金额 */
  paidAmount = undefined;

  /** 应付金额 */
  payableAmount = undefined;

  /** pod上传附件 */
  podFile = "";

  /** 是否上传POD附件 */
  podFileFlag = undefined;

  /** 海外pod签收时间 */
  podSignTime = "";

  /** pod上传时间 */
  podUploadTime = "";

  /** 时效状态 0 正常 1 超时 2 未查到站点/时效天数 */
  prescriptionStatus = undefined;

  /** 时效状态-未查到站点/时效天数 */
  prescriptionStatusInvalid = "";

  /** 时效状态-正常 */
  prescriptionStatusNormal = "";

  /** 时效状态-超时 */
  prescriptionStatusOvertime = "";

  /** sku中文标题 */
  productSkuName = "";

  /** 数量 */
  qty = undefined;

  /** 放行时间 */
  releaseTime = "";

  /** 备注 */
  remark = "";

  /** 订舱完成时间 */
  reserveCabinTime = "";

  /** 封条号 */
  sealno = "";

  /** 结算金额 */
  settlementAmount = "";

  /** 结算币种 */
  settlementCurrency = "";

  /** 结算汇率 */
  settlementExchangeRate = undefined;

  /** 结算信息附件 */
  settlementFile = "";

  /** shipment */
  shipment = "";

  /** shipper */
  shipper = "";

  /** 物流方式多选 */
  shippingTypeIn = "";

  /** 店铺信息 */
  shopMessage = "";

  /** 站点 */
  site = "";

  /** SO号 */
  soNo = "";

  /** '来源仓库编号' */
  sourceWarehouseCode = "";

  /** '来源仓库名称' */
  sourceWarehouseName = "";

  /** 起运港 */
  startPort = "";

  /** 起运港地址 */
  startPortAddress = "";

  /** 起运港编号 */
  startPortCode = "";

  /** 起运港名称 */
  startPortName = "";

  /** 状态：10 待绑定，20 待补料，30 待出口报关，40 待进口清关，50 待POD上传，60 待结算，70 已完成 */
  status = undefined;

  /** 订单状态多选，英文逗号分隔 */
  statusIn = "";

  /** 实际报关合同号 */
  suitableContractNo = "";

  /** 补料时间 */
  supplementDataTime = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 是否上传税金单附件,0-否，1-是 */
  taxBillFileFlag = undefined;

  /** timeOutReasonCategory */
  timeOutReasonCategory = "";

  /** TMS单号 */
  tmsno = "";

  /** TMS单号多选，英文逗号分隔 */
  tmsnoIn = "";

  /** 总件数(TO单数量) */
  toQty = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 拖车代理 */
  trailerAgent = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 美元汇率 */
  usdExchangeRate = undefined;

  /** 供应商内部代码 */
  vendorInternalCode = "";

  /** 体积 */
  volume = undefined;

  /** 运单号 */
  waybillNo = "";

  /** 过磅重量 */
  weighing = undefined;

  /** 重量 */
  weight = undefined;
}

class TransportMasterResponseDto {
  /** 调拨批次单号 */
  abno = "";

  /** 实际签收时间 */
  actualSignTime = "";

  /** 区域 */
  area = "";

  /** 到仓时间 */
  arriveWarehouseTime = "";

  /** ATA */
  ataTime = "";

  /** ATD */
  atdTime = "";

  /** 账单时间 */
  billTime = "";

  /** 计费单位 */
  billingUnit = "";

  /** 计费重 */
  billingWeight = undefined;

  /** 船公司 */
  boatCompany = "";

  /** 箱数 */
  boxQty = undefined;

  /** 箱重 */
  boxWeight = undefined;

  /** 是否自拖自报 0:否 1:是 */
  byselfFlag = undefined;

  /** 类型：10 工厂整柜，20 工厂散货，30 自营整柜，40 自营散货 */
  cabinType = undefined;

  /** centerId */
  centerId = "";

  /** consignee */
  consignee = "";

  /** 货柜号 */
  containerNo = "";

  /** 报关合同号 */
  contractNo = "";

  /** 物流费用明细 */
  costDtoList = [];

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 订舱需求号 */
  crno = "";

  /** 币种 */
  currency = "";

  /** 清关完成时间 */
  customsClearanceTime = "";

  /** 是否查验 0.否 1.是 */
  customsInspectionFlag = undefined;

  /** 报关专员 */
  declarationOwner = "";

  /** 报关代理 */
  declareAgent = "";

  /** 报关代理编码 */
  declareAgentCode = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 是否为草稿 0:否 1:是 */
  draftFlag = undefined;

  /** 截单日期 */
  endBillTime = "";

  /** 目的港 */
  endPort = "";

  /** 截关日期 */
  endTariffTime = "";

  /** 预估结算时间 */
  estimateSettlementTime = "";

  /** 预计签收时间 */
  estimateSignTime = "";

  /** 预估运费 */
  estimatedFreight = undefined;

  /** ETA */
  etaTime = "";

  /** ETD */
  etdTime = "";

  /** 汇率 */
  exchangeRate = undefined;

  /** 出口报关附件 */
  exportDeclarationFile = "";

  /** 出口报关单号 */
  exportDeclarationNo = "";

  /** 出口报关完成时间 */
  exportDeclarationTime = "";

  /** 提取时间 */
  extractTime = "";

  /** finalDelivery */
  finalDelivery = undefined;

  /** 头程费用 */
  headTripFee = undefined;

  /** 附件 */
  headTripFeeFile = "";

  /** 头程费用修改时间 */
  headTripFeeTime = "";

  /** id */
  id = undefined;

  /** 进口清关附件 */
  importClearanceFile = "";

  /** 进口清关提交时间 */
  importClearanceSubmitTime = "";

  /** 进口清关完成时间 */
  importClearanceTime = "";

  /** 在途周期 */
  inTransitCycle = undefined;

  /** 提单附件 */
  ladingBillFile = "";

  /** 装柜地址 */
  loadCabinAddress = "";

  /** 装柜备注 */
  loadCabinRemark = "";

  /** 装柜类型: 10 散货,20 20GP,30 40HQ, 40 40GP */
  loadCabinType = undefined;

  /** 渠道服务编号 */
  logisticsChannelCode = "";

  /** 渠道服务名称 */
  logisticsChannelName = "";

  /** 物流发运时间 */
  logisticsDeliveryTime = "";

  /** 物流专员 */
  logisticsOwner = "";

  /** 渠道商编号 */
  logisticsProviderCode = "";

  /** 渠道商名称 */
  logisticsProviderName = "";

  /** 物流信息 */
  logisticsTrackingInfo = "";

  /** 物流备注 */
  logisticsTrackingRemark = "";

  /** 物流跟踪状态 */
  logisticsTrackingStatus = undefined;

  /** 物流方式：1 龙舟空运 ，2 龙舟海运 ，10 普通空运 ，20 普通海运 ，30 快船 ，40 铁路 ，50 卡车，60 快递 */
  logisticsType = undefined;

  /** 最大数量海关编码 */
  maxHsCode = "";

  /** 最大数量品名 */
  maxProductName = "";

  /** 超期天数 */
  overdueDays = undefined;

  /** 包装单位；10 CTNS,20 PLTS */
  packingUnit = undefined;

  /** 已付金额 */
  paidAmount = undefined;

  /** 应付金额 */
  payableAmount = undefined;

  /** pod上传附件 */
  podFile = "";

  /** 是否上传POD附件 */
  podFileFlag = undefined;

  /** 海外pod签收时间 */
  podSignTime = "";

  /** pod上传时间 */
  podUploadTime = "";

  /** 时效状态 1.超时 0.正常 2.未不到站点/时效天数 */
  prescriptionStatus = undefined;

  /** 数量 */
  qty = undefined;

  /** 其他原因 */
  reasonOther = "";

  /** 放行时间 */
  releaseTime = "";

  /** 备注 */
  remark = "";

  /** 订舱完成时间 */
  reserveCabinTime = "";

  /** 开船周期 */
  sailingCycle = undefined;

  /** 封条号 */
  sealno = "";

  /** 结算金额 */
  settlementAmount = "";

  /** 结算币种 */
  settlementCurrency = "";

  /** 结算汇率 */
  settlementExchangeRate = undefined;

  /** 结算信息附件 */
  settlementFile = "";

  /** shipper */
  shipper = "";

  /** 店铺信息 */
  shopMessage = "";

  /** 签收周期 */
  signInPeriod = undefined;

  /** 站点 */
  site = "";

  /** SO号 */
  soNo = "";

  /** '来源仓库编号' */
  sourceWarehouseCode = "";

  /** '来源仓库名称' */
  sourceWarehouseName = "";

  /** 起运港 */
  startPort = "";

  /** 起运港地址 */
  startPortAddress = "";

  /** 起运港编号 */
  startPortCode = "";

  /** 起运港名称 */
  startPortName = "";

  /** 状态：10 待绑定，20 待补料，30 待出口报关，40 待进口清关，50 待POD上传，60 待结算，70 已完成 */
  status = undefined;

  /** 实际报关合同号 */
  suitableContractNo = "";

  /** 补料时间 */
  supplementDataTime = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 税金单附件 */
  taxBillFile = "";

  /** 是否包税 0否 1是 */
  taxInclusiveFlag = undefined;

  /** timeOutReasonCategory */
  timeOutReasonCategory = "";

  /** TMS单号 */
  tmsno = "";

  /** 总件数(TO单数量) */
  toQty = undefined;

  /** 提单信息明细 */
  traBiDeDtoList = [];

  /** 物流信息明细 */
  traCoDeDtoList = [];

  /** TO信息明细 */
  traDeDtoList = [];

  /** 物流开票明细 */
  traSkuDeDtoList = [];

  /** trackingNo */
  trackingNo = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 拖车代理 */
  trailerAgent = "";

  /** 拖车代理编码 */
  trailerAgentCode = "";

  /** 发货天数 */
  transportDays = undefined;

  /** 车牌信息 */
  transportLicensePlateResponseDto = new TransportLicensePlateResponseDto();

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 美元汇率 */
  usdExchangeRate = undefined;

  /** 供应商内部代码 */
  vendorInternalCode = "";

  /** 体积 */
  volume = undefined;

  /** 运单号 */
  waybillNo = "";

  /** 过磅重量 */
  weighing = undefined;

  /** 重量 */
  weight = undefined;
}

class TransportNotRequiredRequestDto {
  /** 计费重 */
  billingWeight = undefined;

  /** 箱重 */
  boxWeight = undefined;

  /** 是否自拖自报 0:否 1:是 */
  byselfFlag = undefined;

  /** 货柜号 */
  containerNo = "";

  /** 报关代理 */
  declareAgent = "";

  /** 目的港 */
  endPort = "";

  /** 截关日期 */
  endTariffTime = "";

  /** 预估结算时间 */
  estimateSettlementTime = "";

  /** 出口报关附件 */
  exportDeclarationFile = "";

  /** 提单附件 */
  ladingBillFile = "";

  /** 装柜备注 */
  loadCabinRemark = "";

  /** 封条号 */
  sealno = "";

  /** 结算信息附件 */
  settlementFile = "";

  /** 店铺信息 */
  shopMessage = "";

  /** TMS单号 */
  tmsno = "";

  /** 拖车代理 */
  trailerAgent = "";

  /** 过磅重量 */
  weighing = undefined;
}

class TransportSkuDetailRequestDto {
  /** BU编码 */
  buCode = "";

  /** BU名称 */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 关单明细号 */
  customsDeclarationDetailNo = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** sku中文标题 */
  productSkuName = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** tms单号 */
  tmsno = "";

  /** 开票单位 */
  unitNameCn = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class TransportSkuDetailResponseDto {
  /** BU编码 */
  buCode = "";

  /** BU名称 */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 关单明细号 */
  customsDeclarationDetailNo = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** sku中文标题 */
  productSkuName = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** tms单号 */
  tmsno = "";

  /** 开票单位 */
  unitNameCn = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class TransportTaxIncludeRequestDto {
  /** 是否包税 */
  taxInclusiveFlag = undefined;

  /** TMS单号 */
  tmsno = "";
}

class TransportToDetailBean {
  /** 调拨单号 */
  aono = "";

  /** 箱数 */
  boxQty = undefined;

  /** 渠道编号 */
  platformKey = "";

  /** 渠道名字 */
  platformName = "";

  /** 总数量 */
  qty = undefined;

  /** shipment */
  shipment = "";

  /** 体积 */
  volume = undefined;

  /** 重量 */
  weight = undefined;
}

class TransportToDetailDao {
  /** TO明细列表 */
  detailRequestParamsDtoList = [];

  /** TMS单号 */
  tmsno = "";
}

class TransportToDetailDto {
  /** 调拨单号 */
  aono = "";

  /** 箱数 */
  boxQty = undefined;

  /** 币种 */
  currency = "";

  /** 汇率 */
  exchangeRate = undefined;

  /** id */
  id = undefined;

  /** 已付金额 */
  paidAmount = undefined;

  /** 应付金额 */
  payableAmount = undefined;

  /** 总数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** shipment */
  shipment = "";

  /** TMS单号 */
  tmsno = "";

  /** 体积 */
  volume = undefined;

  /** 重量 */
  weight = undefined;
}

class TransportToDetailResponseDto {
  /** 调拨单号 */
  aono = "";

  /** 箱数 */
  boxQty = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 删除标识 0:否 >0:是 */
  deleted = undefined;

  /** 汇率 */
  exchangeRate = undefined;

  /** id */
  id = undefined;

  /** 已付金额 */
  paidAmount = undefined;

  /** 应付金额 */
  payableAmount = undefined;

  /** 渠道编号 */
  platformKey = "";

  /** 渠道名字 */
  platformName = "";

  /** 总数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** shipment */
  shipment = "";

  /** TMS单号 */
  tmsno = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 体积 */
  volume = undefined;

  /** 重量 */
  weight = undefined;
}

class TrasportTrackRequestDto {
  /** 实际签收时间 */
  actualSignTime = "";

  /** ATA */
  ataTime = "";

  /** ATD */
  atdTime = "";

  /** 是否查验 0.否 1.是 */
  customsInspectionFlag = undefined;

  /** 预计签收时间 */
  estimateSignTime = "";

  /** 提取时间 */
  extractTime = "";

  /** 尾程配送方式 1.卡派，2.快递派 */
  finalDelivery = undefined;

  /** 进口清关完成时间 */
  importClearanceTime = "";

  /** 物流信息 */
  logisticsTrackingInfo = "";

  /** 物流备注 */
  logisticsTrackingRemark = "";

  /** 物流跟踪状态 */
  logisticsTrackingStatus = undefined;

  /** pod上传附件 */
  podFile = "";

  /** 其他原因 */
  reasonOther = "";

  /** 税金单附件 */
  taxBillFile = "";

  /** 超时原因分类 */
  timeOutReasonCategory = "";

  /** TMS单号 */
  tmsno = "";

  /** 追踪编码 */
  trackingNo = "";
}

class UpdateCustomsDeclarationFileRequestDto {
  /** 出口报关附件 */
  customsDeclarationFile = "";

  /** 来源单号单号 */
  sourceNo = "";
}

class UpdateHeadTripFeeRequestParamsDto {
  /** 头程费用 */
  headTripFee = undefined;

  /** 附件 */
  headTripFeeFile = "";

  /** tms单号 */
  tmsNo = "";
}

class UploadDeclarationFilesRequestDto {
  /** 报关批次号 */
  cbNo = "";

  /** 是否查验 */
  checkFlag = undefined;

  /** 合同号 */
  contractNo = "";

  /** 申报日期 */
  declarationTime = "";

  /** 报关单号 */
  declareNo = "";

  /** 附件数组 */
  filesList = [];
}

class ZoneTemplateCreateRequestDto {
  /** 描述 */
  description = "";

  /** 分区模板明细 */
  detailCreateRequestDtos = [];

  /** 分区ID  编辑分区时必传 */
  id = undefined;

  /** 分区模式 0:按国家 1:按国家+邮编 */
  zoneModel = undefined;

  /** 分区名称 */
  zoneName = "";
}

class ZoneTemplateDetailCreateRequestDto {
  /** 分区明细id  编辑时必传 */
  id = undefined;

  /** 邮编范围止 */
  postcodeEnd = "";

  /** 邮编范围起 */
  postcodeStart = "";

  /** 目的国家数简码 */
  targetCountryCode = "";

  /** 目的国家名称 */
  targetCountryName = "";

  /** 分区id */
  zoneId = undefined;

  /** 分区模式 0:按国家 1:按国家+邮编 */
  zoneModel = undefined;

  /** 分区名称 */
  zoneName = "";
}

class ZoneTemplateDetailRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 邮编范围止 */
  postcodeEnd = "";

  /** 邮编范围起 */
  postcodeStart = "";

  /** 目的国家数简码 */
  targetCountryCode = "";

  /** 目的国家名称 */
  targetCountryName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 分区id */
  zoneId = undefined;

  /** 分区模式 0:按国家 1:按国家+邮编 */
  zoneModel = undefined;

  /** 分区名称 */
  zoneName = "";
}

class ZoneTemplateDetailResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 邮编范围止 */
  postcodeEnd = "";

  /** 邮编范围起 */
  postcodeStart = "";

  /** 目的国家数简码 */
  targetCountryCode = "";

  /** 目的国家名称 */
  targetCountryName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 分区id */
  zoneId = undefined;

  /** 分区模式 0:按国家 1:按国家+邮编 */
  zoneModel = undefined;

  /** 分区名称 */
  zoneName = "";
}

class ZoneTemplateRequestParamsDto {
  /** 国家编号 */
  countryCode = "";

  /** 国家名称 */
  countryName = "";

  /** 创建起始时间 */
  createBeginTime = "";

  /** 创建人 */
  createBy = "";

  /** 创建结束时间 */
  createEndTime = "";

  /** 描述 */
  description = "";

  /** id */
  id = undefined;

  /** 邮编起始范围 */
  postcodeEnd = "";

  /** 邮编起始范围 */
  postcodeStart = "";

  /** 分区模式 0:按国家 1:按国家+邮编 */
  zoneModel = undefined;

  /** 分区名称 */
  zoneName = "";
}

class ZoneTemplateResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 描述 */
  description = "";

  /** 分区明细 */
  detailResponseDtos = [];

  /** id */
  id = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 分区模式 0:按国家 1:按国家+邮编 */
  zoneModel = undefined;

  /** 分区名称 */
  zoneName = "";
}

export const tms = {
  ActivitiApplyRequestDto,
  ApprovalBeforeRequestDto,
  ApprovalRequestDto,
  ApproveBatchRequestDto,
  AssigneeDto,
  AssociatedFilesRequestDto,
  AssociatedFilesResponseDto,
  BatchImportSettlementRequestDto,
  CabinAdvanceCreateRequestDto,
  CabinAdvanceDetailCreateRequestDto,
  CabinAdvanceDetailResponseDto,
  CabinAdvanceMasterResponseDto,
  CabinFactoryActualCabinetRequestDto,
  CabinFactoryCreateRequestDto,
  CabinFactoryDeliveryRequestDto,
  CabinFactoryInboundRequestDto,
  CabinFactoryLockWarehouseRequestDto,
  CabinFactoryOutboundRequestDto,
  CabinFactoryPickupCabinRequestDto,
  CabinFactoryPlanCabinetCabinRequestDto,
  CabinFactoryPurchaseExamineRequestDto,
  CabinFactoryReserveCabinRequestDto,
  CabinFactoryToWarehouseRequestDto,
  CabinFactoryTransferRequestDto,
  CabinLinkAllocationResponseDto,
  CabinMasterDataResponseDto,
  CabinMasterRequestDto,
  CabinMasterResponseDto,
  CabinPoDetailDataResponseDto,
  CabinPoDetailRequestDto,
  CabinPoDetailResponseDto,
  CabinSelfCreateRequestDto,
  CabinSelfReserveCabinRequestDto,
  CabinSelfWarehouseExamineRequestDto,
  CabinSkuDetailDataResponseDtoReq,
  CabinSkuDetailDataResponseDtoRes,
  CabinSkuDetailRequestDto,
  CabinSkuDetailResponseDto,
  CabinToDetailDataResponseDto,
  CabinToDetailRequestDto,
  CabinToDetailResponseDto,
  CashFlowRequestParamsDto,
  CashFlowResponseDto,
  CbsPaymentResponseDto,
  CostRequestReportRequestDto,
  CostRequestRequestDto,
  CostRequestRequestParamsDto,
  CostRequestResponseDto,
  CostRequestUpdateDto,
  CostToPayRequestDto,
  CostTypeRequestDto,
  CostTypeResponseDto,
  CountryResponseDto,
  CurrentTaskDto,
  CustomDeclarationResponseRpcDto,
  CustomsClearanceDSHRequestDto,
  CustomsClearanceDetailReportExcelResponseDto,
  CustomsClearanceDetailsRequestDto,
  CustomsClearanceDetailsResponseDto,
  CustomsClearanceDownloadResponseDto,
  CustomsClearanceRequestDto,
  CustomsClearanceRequestParamsDto,
  CustomsClearanceResponseDto,
  CustomsClearanceYFXRequestDto,
  CustomsClearanceYHDRequestDto,
  CustomsDeclarationApplyDetailsRequestDto,
  CustomsDeclarationApplyDetailsResponseDto,
  CustomsDeclarationContractRequestDto,
  CustomsDeclarationContractResponseDto,
  CustomsDeclarationDetailsRequestDto,
  CustomsDeclarationItemRequestDto,
  CustomsDeclarationItemResponseDto,
  CustomsDeclarationMasterRequestDto,
  CustomsDeclarationMasterResponseDto,
  DeclarationDownloadResponseDto,
  DeclareContractRequestParamsDto,
  DeclareContractResponseDto,
  ExportDeclarationAbnormalCloseRequestDto,
  ExportDeclarationContractAndDeclarationRequestDto,
  ExportDeclarationDSHRequestDto,
  ExportDeclarationDownloadResponseDto,
  ExportDeclarationExportFileRequestDto,
  ExportDeclarationRequestParamsDto,
  ExportDeclarationResponseDto,
  ExportDeclarationYFXRequestDto,
  ExportDeclarationYHDRequestDto,
  FinanceAndTaxationMasterResponseDto,
  FinanceAndTaxationResponseDto,
  FreightResponseDto,
  IPage,
  LogisticsChannelCreateRequestDto,
  LogisticsChannelLimitRequestDto,
  LogisticsChannelLimitResponseDto,
  LogisticsChannelLimitUpdateDto,
  LogisticsChannelListResponseDto,
  LogisticsChannelLogisticsGroupRequestDto,
  LogisticsChannelLogisticsGroupResponseDto,
  LogisticsChannelLogisticsGroupUpdateDto,
  LogisticsChannelMappingModel,
  LogisticsChannelPlatformDto,
  LogisticsChannelPlatformRequestDto,
  LogisticsChannelPlatformResponseDto,
  LogisticsChannelPriceCreateRequestDto,
  LogisticsChannelPriceResponseDto,
  LogisticsChannelPriceUpdateRequestDto,
  LogisticsChannelRequestDto,
  LogisticsChannelResponseDto,
  LogisticsChannelTobCreateRequestDto,
  LogisticsChannelTobRequestParamsDto,
  LogisticsChannelTobResponseDto,
  LogisticsChannelTobUpdateRequestDto,
  LogisticsChannelUpdateRequestDto,
  LogisticsChannelWarehouseRequestDto,
  LogisticsChannelWarehouseResponseDto,
  LogisticsChannelZoneCreateRequestDto,
  LogisticsChannelZoneResponseDto,
  LogisticsChannelZoneUpdateDto,
  LogisticsGroupResponseDto,
  LogisticsMatchDetailRequestDto,
  LogisticsMatchRequestDto,
  LogisticsMatchResponseDto,
  LogisticsMatchTestDto,
  LogisticsPlatformResponseDto,
  LogisticsProviderCreateRequestDto,
  LogisticsProviderPaymentRequestDto,
  LogisticsProviderPaymentResponseDto,
  LogisticsProviderPaymentTobRequestDto,
  LogisticsProviderPaymentTobResponseDto,
  LogisticsProviderResponseDto,
  LogisticsProviderTobCreateRequestDto,
  LogisticsProviderTobRequestParamsDto,
  LogisticsProviderTobResponseDto,
  LogisticsProviderTobUpdateRequestDto,
  LogisticsProviderUpdateRequestDto,
  LogisticsQuotationCreateDto,
  LogisticsQuotationDetailTobRequestDto,
  LogisticsQuotationDetailTobRequestParamsDto,
  LogisticsQuotationDetailTobResponseDto,
  LogisticsQuotationInfoCreateDto,
  LogisticsQuotationInfoRequestDto,
  LogisticsQuotationInfoResponseDto,
  LogisticsQuotationInfoUpdateDto,
  LogisticsQuotationPriceTobRequestDto,
  LogisticsQuotationRequestDto,
  LogisticsQuotationResponseDto,
  LogisticsQuotationSurchargeFormulaCreateDto,
  LogisticsQuotationSurchargeFormulaRequestDto,
  LogisticsQuotationSurchargeFormulaResponseDto,
  LogisticsQuotationSurchargeFormulaUpdateDto,
  LogisticsQuotationSurchargeInfoCreateDto,
  LogisticsQuotationSurchargeInfoRequestDto,
  LogisticsQuotationSurchargeInfoResponseDto,
  LogisticsQuotationSurchargeInfoUpdateDto,
  LogisticsQuotationSurchargeRuleCreateDto,
  LogisticsQuotationSurchargeRuleRequestDto,
  LogisticsQuotationSurchargeRuleResponseDto,
  LogisticsQuotationSurchargeRuleUpdateDto,
  LogisticsQuotationTobRequestDto,
  LogisticsQuotationTobRequestParamsDto,
  LogisticsQuotationTobResponseDto,
  LogisticsQuotationUpdateDto,
  LogisticsQuotationZoneCreateDto,
  LogisticsQuotationZoneRequestDto,
  LogisticsQuotationZoneResponseDto,
  LogisticsQuotationZoneUpdateDto,
  LogisticsTariffThresholdCreateRequestDto,
  LogisticsTariffThresholdResponseDto,
  LogisticsTariffThresholdUpdateRequestDto,
  MergeCustomsDeclarationRequestDto,
  PageInfo,
  PayRequestPartialPaymentDto,
  PayRequestResultDto,
  PayUploadBillFileRequestDto,
  PayUploadFileRequestDto,
  PaymentDetailBean,
  PaymentDetailRequestParamsDto,
  PaymentMasterRequestParamsDto,
  PaymentMasterResponseDto,
  PaymentToDetailRequestDto,
  PlatformLogisticsRequestParamsDto,
  PlatformLogisticsResponseDto,
  Response,
  ResponseDto,
  SiteEfficiencyMasterRequestDto,
  SiteEfficiencyMasterResponseDto,
  StartPortRequestDto,
  StartPortRequestParamsDto,
  StartPortResponseDto,
  StockOccupyDetailResponseDto,
  StockOccupyForBillRequestDto,
  StockOccupyForBillSkuRequestDto,
  StockOccupyMasterAddRequestDto,
  StockOccupyMasterResponseDto,
  StockOccupyMasterResponseRpcDto,
  StockOccupyMasterSelectRequestDto,
  StockOccupyMasterSelectSkuRequestDto,
  StockOccupySkuAddRequestDto,
  SupplierSkuDeliverableResponseRpcDto,
  TariffThresholdResponseDto,
  TaskDto,
  TaxRefundMatchingRequestDto,
  TaxRefundMatchingResponseDto,
  ToLogisticsChannelResponseDto,
  TransportBillDetailRequestDto,
  TransportBillDetailResponseDto,
  TransportCourierDetailRequestDto,
  TransportCourierDetailResponseDto,
  TransportDbdRequestDto,
  TransportDblRequestDto,
  TransportDckRequestDto,
  TransportDjfRequestDto,
  TransportDjkRequestDto,
  TransportDjsRequestDto,
  TransportDlrRequestDto,
  TransportDpodRequestDto,
  TransportDraftBoxMasterRequestDto,
  TransportFinanceDetailReportResponseDto,
  TransportFinanceDetailRequestParamsDto,
  TransportLicensePlateRequestDto,
  TransportLicensePlateResponseDto,
  TransportMasterRequestParamsDto,
  TransportMasterResponseDto,
  TransportNotRequiredRequestDto,
  TransportSkuDetailRequestDto,
  TransportSkuDetailResponseDto,
  TransportTaxIncludeRequestDto,
  TransportToDetailBean,
  TransportToDetailDao,
  TransportToDetailDto,
  TransportToDetailResponseDto,
  TrasportTrackRequestDto,
  UpdateCustomsDeclarationFileRequestDto,
  UpdateHeadTripFeeRequestParamsDto,
  UploadDeclarationFilesRequestDto,
  ZoneTemplateCreateRequestDto,
  ZoneTemplateDetailCreateRequestDto,
  ZoneTemplateDetailRequestParamsDto,
  ZoneTemplateDetailResponseDto,
  ZoneTemplateRequestParamsDto,
  ZoneTemplateResponseDto,
};
